
import Konva from 'konva';

import {
  maleDefaultColor,
  femaleDefaultColor,
  unGenderedDefaultColor,
  maleDefaultColorLight,
  femaleDefaultColorLight,
  unGenderedDefaultColorLight,
  unrelatedColor,
  exStockColors,
  widthScale,
  heightScale,
  nodeWidth,
  nodeHeight,
  viewPortBuffer,
  targetFocusDesktopScale,
  imageBasePath,
  distanceBetweenNodes,
  handleHeight,
  goalPostHeight,
  oneGenerationVerticalDistance,
  translatedLabels,
  isSafari,
  focusColor,
  fontFamily,
  fullNameFontSize,
  fullNameFontColor,
  fullNameLineWidthDefaultTreeNormalFont,
  fullNameLineWidthDefaultTreeLargeFont,
  fullNameLineWidthPedigreeTreeNormalFont,
  fullNameLineWidthDualPedigreeTreeNormalFont,
  fullNameLineWidthPedigreeTreeLargeFont,
  fullNameFontStyle,
  fullNameLineHeight,
  // privateColor,
  isDevelopment,
  treeSessionId,
  // rangeKeyIncrement,
  dimDualPedigreeSVGFrames,
  widenDualPedigreeBranchesBy,
  defaultZoomLevelValueForDualPedigree,
  // dualPedigreeMode,
  fontArray,
  dualPedigreeMode,
  minimal,
  minScreenWidthFanchart,
} from './constants';


import { truncate, compact, uniqBy, sortBy } from 'lodash';

export function enableContextMenuForGeni() {
  const appDiv = document.getElementById('app');
  appDiv.dataset.oncontextmenu = 'true';
}

export function getInitialPrId() {
  const href = window.location.href;
  const path = href.split('?')[0];
  const pathArray = path.split('/');
  const lastElementOfPathArray = pathArray.slice(-1)[0];
  const intitalPrId = lastElementOfPathArray.split('#')[0];
  return intitalPrId;
}

let grandparentRow = null;
let focusRow = null

const queryCheck = s => document.createDocumentFragment().querySelector(s)
export function isSelectorValid(selector){ // https://stackoverflow.com/questions/34849001/check-if-css-selector-is-valid/42149818
  try { queryCheck(selector) } catch (err) { return false }
  return true
}

export function getComputedDomValue({element, cssProp}) {
  return parseInt(window.getComputedStyle(element, null).getPropertyValue(cssProp), 10);
}

export function simulate({el, event}) {
  if (el.fireEvent) {
    el.fireEvent('on' + event);
  } else {
    var evObj = document.createEvent('Events');
    evObj.initEvent(event, true, false);
    el.dispatchEvent(evObj);
  }
}

export function onlyUnique(value, index, self) {   //https://stackoverflow.com/questions/1960473/get-all-unique-values-in-a-javascript-array-remove-duplicates
    return self.indexOf(value) === index;
}

export function countUniqueValues(arr) {
  // Create a Set to store unique values
  const uniqueValues = new Set();

  // Loop through the array and add each value to the Set
  for (const value of arr) {
    uniqueValues.add(value);
  }

  // Return the size of the Set, which represents the count of unique values
  return uniqueValues.size;
}

export function sortObject(obj) {
  return Object.keys(obj).sort().reduce(function (result, key) {
      result[key] = obj[key];
      return result;
  }, {});
}

export function getFontWidths({uniqueFanChartChars, fontName, fontSize}) {
    let hash = {};

    uniqueFanChartChars.forEach((char) => {
      const span = document.createElement('span');
      span.textContent = char;
      span.style.fontFamily = fontName;
      span.style.fontSize = fontSize + 'px';
      document.body.appendChild(span);
      let outterWidth = span.offsetWidth;
      if(outterWidth > 0 ){
        hash[char] = outterWidth;
      }
      document.body.removeChild(span);
  });
  return hash;
}

export function mockRequest1() {
   return new Promise((resolve) => {
     setTimeout(() => {
      console.log('mockRequest resolving ');
       resolve({
            email : "somemockemail@email.com",
            repository: "http://github.com/username"
       });
     }, 3000);
   });
}

export function isVisible(idName) {
  const el = document.querySelector('#' + idName);
  if(el !== null && window.getComputedStyle(el).display !== "none") { return true; }
  return false
}

export function mockRequest2() {
   return new Promise((resolve) => {
     setTimeout(() => {
      console.log('mockRequest resolving 2');
       resolve({
            email : "jamesming@gmail.com",
            repository: "http://github.com/jamesming"
       });
     }, 2000);
   });
 }

export function wrap({toWrap, wrapper, idName}) {
    wrapper = wrapper || document.createElement('div');
    toWrap.parentNode.appendChild(wrapper);
    wrapper.setAttribute('id', idName);
    return wrapper.appendChild(toWrap);
}

export function add(x, y) {
  return x + y;
}


export function shrinkDimBy({dim, howmuch}){
  dim.width = dim.width * howmuch;
  dim.height = dim.height * howmuch;
  return dim;
}

export function findDifference({array1, array2}){ //https://stackoverflow.com/questions/50648091/check-the-difference-between-two-arrays-of-objects-in-javascript
  return array1.filter(item1 =>
  !array2.some(item2 => (item2.id === item1.id && item2.name === item1.name)));
}

export function urlGet(name){
  name = name.replace(/[[]/,"\\[").replace(/[\]]/,"\\]");
  var regexS ="[\\?&]"+name+"=([^&#]*)";
  var regex = new RegExp( regexS );
  var results = regex.exec(window.location.href);
  if( results == null )
    return false;
  else
    return results[1];
}


 export function decodeHtmlEntities (input){
  const tempElement = document.createElement('div');
  tempElement.innerHTML = input;
  return tempElement.textContent;
}

export function filterQuestionMarkFromURL(url) {
  const filteredSegment = url.split('?');
  return filteredSegment[0];
}

export function parseOutLastSegmentOfUrl(url) {
  const urlSegments = url.split('/');
  const lastSegment = urlSegments[urlSegments.length - 1];
  return lastSegment;
}

export function isValidEmail(email) {

    const emailCannotBeEmpty = ( !isDevelopment ? window.trl('Email cannot be empty', 'Email formatting rules'): 'Email cannot be empty');
    const emailMustContainSymbol = ( !isDevelopment ? window.trl(`Email must contain '@' symbol`, 'Email formatting rules'): `Email must contain '@' symbol`);
    const emailMustContainOnlyOneSymbol = ( !isDevelopment ? window.trl(`Email must contain only one '@' symbol`, 'Email formatting rules'): `Email must contain only one '@' symbol`);
    const emailDomainMustContainAtLeastOneDotSymbol = ( !isDevelopment ? window.trl(`Email domain must contain at least one '.' symbol`, 'Email formatting rules'): `Email domain must contain at least one '.' symbol`);
    const emailDomainMustContainAtLeastTwoLettersAfterDot = ( !isDevelopment ? window.trl(`Email domain must contain at least two letters after the '.' symbol`, 'Email formatting rules'): `Email domain must contain at least two letters after the '.' symbol`);

    const errors = {};
    // Check if the email is not null or empty
    if (!email) {
        errors.empty = emailCannotBeEmpty;
    }

    // Check if the email contains '@'
    if (!errors.empty && email.indexOf('@') === -1) {
        errors.missingAt = emailMustContainSymbol;
    }

    // Split the email into parts
    if (!errors.missingAt && !errors.empty) {
        const parts = email.split('@');
    // Check if the email has exactly one '@' symbol
        if (parts.length !== 2) {
            errors.multipleAt = emailMustContainOnlyOneSymbol;
        } else {
            // Get the username and domain parts
            // const username = parts[0];
            const domain = parts[1];
            // Check if the domain contains a '.'
            if (domain.indexOf('.') === -1) {
                errors.missingDot = emailDomainMustContainAtLeastOneDotSymbol;
            } else {
                // Split the domain into parts
                const domainParts = domain.split('.');
                // Check if the domain has at least two letters after the '.'
                if (domainParts[domainParts.length - 1].length < 2) {
                    errors.shortTLD = emailDomainMustContainAtLeastTwoLettersAfterDot;
                }
            }
        }
    }
    if(Object.keys(errors).length >0 )
        return errors;
    else
        return true;
}


export function getDataUrl(img) {
   // Create canvas
   const canvas = document.createElement('canvas');
   const ctx = canvas.getContext('2d');
   // Set width and height
   canvas.width = img.width;
   canvas.height = img.height;
   // Draw the image
   ctx.drawImage(img, 0, 0);
   return canvas.toDataURL('image/jpeg');
}

export const convertObjToArray = ({obj})=>{
  const keysArray = Object.keys(obj);
  return keysArray.map((key)=>{
    // obj[key].key = key;
    return obj[key];
  })
}

export const getPropFromObjInArray = ({arr, searchkey, key, value})=>{
  let searchValue = undefined;
  arr.forEach((obj)=>{
    if(obj[key] === searchkey) searchValue = obj[value];
  });
  return searchValue;
}

export const cloneVar = ( item ) => {
  return [ item  ].slice(0)[0]
}

export const screenCanShowModal = ( {minWidth} ) => {
  if( isLandscape() && window.screen.width > minWidth ) return true;
  if( !isLandscape() && window.screen.height > minWidth ) return true;
  return false;
};

export const isChrome = () => {
  return (/chrome/i.test(navigator.userAgent));
};

export const isMobilePhone = () => {

  const checkIfMobilePhone = !isLandscape() && !isMobileTablet() &&
    (/Android|webOS|iPhone|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent));

  return checkIfMobilePhone;

};

export const isWindows = () => {

  const checkIfWindows = navigator.appVersion.indexOf("Windows") !== -1

  return checkIfWindows;

};

export const isMobileIOS = () => {
  return (/iPhone|iPod|iPad/i.test(navigator.userAgent));
};

export const isFireFox = () => {
  return (typeof InstallTrigger !== 'undefined');
};

// export const isFireFox = () => {
//   return navigator.userAgent.indexOf("Firefox") > -1;
// };

export const deviceHasTouchScreen = () => { //https://community.articulate.com/discussions/building-better-courses/code-to-determine-what-type-of-device-was-used-tablet-and-smartphone
  let hasTouchScreen = false;
  if ("maxTouchPoints" in navigator) {
   hasTouchScreen = navigator.maxTouchPoints > 0;
  } else if ("msMaxTouchPoints" in navigator) {
   hasTouchScreen = navigator.msMaxTouchPoints > 0;
  } else {
   var mQ = window.matchMedia && matchMedia("(pointer:coarse)");
   if (mQ && mQ.media === "(pointer:coarse)") {
   hasTouchScreen = !!mQ.matches;
   } else if ('orientation' in window) {
   hasTouchScreen = true; // deprecated, but good fallback
   } else {
   // Only as a last resort, fall back to user agent sniffing
   var UA = navigator.userAgent;
   hasTouchScreen = (
   /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
   /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
   );
   }
  }
  return hasTouchScreen;
};

export const isPAD = () => { // https://stackoverflow.com/questions/57765958/how-to-detect-ipad-and-ipad-os-version-in-ios-13-and-up
  return navigator.userAgent.match(/(iPad)/) /* iOS pre 13 */ ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
};

export const isMobile = () => {
  return (/Mobile/i.test(navigator.userAgent));
};

export const isAndroid = () => {
  return (/Android/i.test(navigator.userAgent));
};

export const isAndroidPhone = () => {
  return isAndroid() && isMobile();
};

export const isAndroidTablet = () => {
  return isAndroid() && !isAndroidPhone();
};

export const isMobileTablet = () => {
  return isPAD() || isAndroidTablet()
};

export const isLandscape = () => {
  return window.innerWidth > window.innerHeight;
};

// export const isMobileTablet = () => {
//   return (/iPad/i.test(navigator.userAgent));
// };

// export const isMobileTablet = () => { // https://stackoverflow.com/questions/57765958/how-to-detect-ipad-and-ipad-os-version-in-ios-13-and-up
//   return navigator.userAgent.match(/(iPad)/) /* iOS pre 13 */ ||
//   (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
// };


export const isMobileIphone = () => {
  return (/iPhone/i.test(navigator.userAgent));
};

export const isIE = () => { //https://stackoverflow.com/questions/21825157/internet-explorer-11-detection/21825207#21825207
  return navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > 0;
};

export const isWideMobile = isMobilePhone() && window.innerWidth > window.innerHeight; //dev
export const isWideTablet = isMobileTablet() && window.innerWidth > window.innerHeight; //dev

let failedCount = 0;
export function debugStageCurrent(operation, fromWhere){

  return function() {
      try {
          operation.call(this, this.stage.current);
      } catch (error) {


           console.log(`%c debugStageCurrent`, [
             'color: white',
             'background: red',
             'font-size: 14px',
             'border: 5px solid red',
             'padding: 10px',
             ].join(';'));


          failedCount++;

          console.error('Operation failed:', error);

          const logged = {
                fromWhere,
                minimal,
                isSafari,
                isChrome: isChrome(),
                isFireFox: isFireFox(),
                isIE: isIE(),
                isAndroidTablet: isAndroidTablet(),
                isLandscape: isLandscape(),
                isAndroidPhone: isAndroidPhone(),
                sessionTook: this.sessionTimer.stop(),
                currentIsDefined: this.currentIsDefined,
                currentNotNull: this.currentNotNull,
                userClickerBackOrFowardButton: this.userClickerBackOrFowardButton,
                popedUrlAddress: this.popedUrlAddress.join(':'),
                visted: sortVisitedByValueIncrementOne(this.visited),

                // deviceHasTouchScreen: deviceHasTouchScreen(),
                // isWideMobile: isWideMobile(),
                // isMobilePhone: isMobilePhone(),
              };

          console.log(`logged: `, logged);

          if( typeof(window.Geni) !== 'undefined' ){
            window.Geni.log(logged);
          }

          window.onerror(error.message, window.location.href, null, null, error);
      }
  };
}

export const sortVisitedByValueIncrementOne = (visited) => {
  const sortedVisited = {};
  let count = 1; // Start counting from 1
  // Sort the keys by their original values
  Object.keys(visited).sort((a, b) => {
    return Number(visited[a]) - Number(visited[b]);
  }).forEach((key) => {
    sortedVisited[key] = count++; // Assign sequential values starting from 1
  });
  return sortedVisited;
};

export const timer = () => {
  let startTime;

  return {
    start: () => {
      startTime = performance.now();
    },
    stop: () => {
      const endTime = performance.now();
      let elapsedTime = endTime - startTime;
      return Math.round(elapsedTime / 10) / 100;
    }
  };
}

export const getDummyText = (which) => {

const dummyTextArray = [
  `Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.`,
  `Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua`,
  `Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua`,
  `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua`,
  `Lorem ipsum dolor sit amet, consectetur adipiscing elit,et dolore magna aliqua.`,
  `Lorem ipsum dolor sit amet.`
];

  return (   typeof(which ) !== 'undefined'? dummyTextArray[which]: dummyTextArray[getRandom(0,5)]);
}


// export function urlGet(name) {
//       name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
//       var regexS ="[\\?&]"+name+"=([^&#]*)";
//       var regex = new RegExp( regexS );
//       var results = regex.exec(window.location.href);
//       if( results == null )
//         return false;
//       else
//         return results[1];
// }

export const isElement = ({byId, byClass}) => {
  const element = (typeof(byId) !== 'undefined' ? document.querySelector(`#${byId}`): document.querySelector(`.${byClass}`))
  return element instanceof Element || element instanceof HTMLDocument;
}

export const getRandom = (max, min) => {
  return  Math.floor(Math.random() * (max - min + 1)) + min;
}

export const isEmptyObject = (obj) => {
  if( typeof(obj) == 'undefined' ) return true;
  return Object.keys(obj).length === 0;
}

export const shrinkWordsWidth = ({word, maxLength})=>{

  const wordTruncated = truncate(word, {
      length: maxLength,
      separator: ' '
  });

  // console.log(JSON.stringify({word, maxLength, wordTruncated}, null, 2));

  return wordTruncated;
}

export const shadeColor = (color, percent)=>{

    var R = parseInt(color.substring(1,3),16);
    var G = parseInt(color.substring(3,5),16);
    var B = parseInt(color.substring(5,7),16);

    R = parseInt(R * (100 + percent) / 100, 10);
    G = parseInt(G * (100 + percent) / 100, 10);
    B = parseInt(B * (100 + percent) / 100, 10);

    R = (R<255)?R:255;
    G = (G<255)?G:255;
    B = (B<255)?B:255;

    var RR = (( R.toString(16).length === 1 )?"0"+R.toString(16):R.toString(16));
    var GG = (( G.toString(16).length === 1 )?"0"+G.toString(16):G.toString(16));
    var BB = (( B.toString(16).length === 1 )?"0"+B.toString(16):B.toString(16));

    return "#"+RR+GG+BB;
}

export const findFurthestEdges = ({nodeObjsArray}) => {

  let bottom = 0;
  let top = 99999999999999;
  let leftNode = undefined;
  let rightNode = undefined;

  let right = 0;
  let left = 99999999999999999999;
  nodeObjsArray.forEach((nodeObj)=>{
    if(nodeObj.right > right){
      right = nodeObj.right;
      rightNode = nodeObj.n;
    }
    if(nodeObj.left < left){
      left = nodeObj.left;
      leftNode = nodeObj.n;
    }
    if( nodeObj.bottom > bottom){
      bottom = nodeObj.bottom;
    }
    if( nodeObj.top < top){
      top = nodeObj.top;
    }
  })

  return {
    top,
    left,
    right,
    bottom,
    leftNode,
    rightNode,
  }
}

export const getNodeFromNodeObjsWithPrId = ({nodeObjs, prId, fromWhere}) => {

  if(typeof(fromWhere) !== 'undefined'){
    // console.log('fromWhere: ' + fromWhere);
  }
  else {
    // console.log('fromWhere is undefined');
  }

  for (var n in nodeObjs) {
    if (nodeObjs.hasOwnProperty(n)) {
      const nodeObj = nodeObjs[n];
      if( typeof(nodeObj) !== 'undefined' && nodeObj.pr_id === prId ) {
        return n;
      } else {
      }
    }
  }
  // console.log('No node found.');
  return undefined;
}


export const truncateFullNameLineArrBasedOnFontSize = ( { isPedigree, fontSizeChoice, fullnameArrBasedOnFontSize, lineLength } ) => {

    const getWidth = ( line ) => {
      return getWidthKonvaText({
        str: line,
        fontSize: fullNameFontSize,
        fontFamily,
        fontStyle: fullNameFontStyle,
        lineHeight: fullNameLineHeight})
    }


    let maxWidth = ( fontSizeChoice === 'default' ? fullNameLineWidthDefaultTreeNormalFont: fullNameLineWidthDefaultTreeLargeFont);

    if( typeof(lineLength) === 'undefined' ){
      lineLength = ( fontSizeChoice === 'default' ? 12: 9);
    }

    for( let idx = 0; idx <= 3; idx++){

      if(fontSizeChoice === 'large' && idx === 3){
        lineLength -= 4;
        maxWidth -= maxWidth - 5;
      }

      if( typeof(fullnameArrBasedOnFontSize[idx]) !== 'undefined' &&
          getWidth(fullnameArrBasedOnFontSize[idx]) > maxWidth
      ){
        fullnameArrBasedOnFontSize[idx] = truncateWord({
            str:fullnameArrBasedOnFontSize[idx],
            length: lineLength,
            useWordBoundary: false,
            fromWhere: 'fullname',
          }
        )
      }
    }

    return fullnameArrBasedOnFontSize;

  }


export const getNodeFromNodeObjsWithPid = ({nodeObjs, pid, fromWhere}) => {

  let nodeNumbers = [];

  if(typeof(fromWhere) !== 'undefined'){
    // console.log('fromWhere: ' + fromWhere);
  }
  else {
    // console.log('fromWhere is undefined');
  }

  for (var n in nodeObjs) {
    if (nodeObjs.hasOwnProperty(n)) {
      const nodeObj = nodeObjs[n];
      if( typeof(nodeObj.pid) !== 'undefined' && nodeObj.pid.toString() === pid.toString()) {
        nodeNumbers.push(n);
      } else {
      }
    }
  }

  return ( nodeNumbers.length > 0 ? nodeNumbers: undefined);
}


export const  buildFullNameLineArrBasedOnFontSize = ({isPedigree, fontSizeChoice, nm, n/*, maxWidth*/}) => {

    let rowsNames = [];
    let eachLineSofar = '';
    let soFarLength = 0;
    let nameWidth = 0;
    // let remainingStr = '';

    const fontSize = fullNameFontSize;
    const fontStyle = fullNameFontStyle;
    const lineHeight = fullNameLineHeight;

    /*

      let spaceUsingKonva = new Konva.Text({
            x: 0,
            y: 0,
            text: ' ',
            fontSize,
            fontFamily,
            fontStyle,
            lineHeight,
            align: 'left'
          });

      spaceWidth = spaceUsingKonva.width();

     */

    const maxWidthMapDefaultTreeMap = {
      'default': fullNameLineWidthDefaultTreeNormalFont,
      'large': fullNameLineWidthDefaultTreeLargeFont,
    }

    const maxWidthMapPedigreeTreeMap = {
      'default': fullNameLineWidthPedigreeTreeNormalFont,
      'large': fullNameLineWidthPedigreeTreeLargeFont,
    }

    let maxWidth = ( !isPedigree ? maxWidthMapDefaultTreeMap[fontSizeChoice]: maxWidthMapPedigreeTreeMap[fontSizeChoice]);

    let _nmArray = [];
    let _name = [];
    // let hasHypen = false;
    let nmArr = nm.split(" ");

    nmArr.forEach((name)=>{
      if( name.includes('-')){
        // hasHypen = true;
        _name = name.split("-")
        _nmArray.push(_name[0] + '-');
        _nmArray.push(_name[1]);
      } else {
        _nmArray.push(name)
      }
    })
    nmArr = _nmArray;
    // if( hasHypen ) console.log(`nmArr: `, JSON.stringify(nmArr, null, 2));

    nmArr.forEach((name, idx) =>{

      let nameUsingKonva = new Konva.Text({
            x: 0,
            y: 0,
            text: name + ' ',
            fontSize,
            fontFamily,
            fontStyle,
            lineHeight,
            align: 'left'
          });

      nameWidth = nameUsingKonva.width();

      soFarLength += nameWidth;

      if( soFarLength >= maxWidth ) {
        if(eachLineSofar !== ''){
          rowsNames.push(eachLineSofar.trim());
        }
        soFarLength = nameWidth;
        eachLineSofar = '';
      } else{

      }

      eachLineSofar += name + ' ';
      // remainingStr = name;

    })

    // if( n === '1'){

    //   if(typeof(window.doThisOnce) === 'undefined') window.doThisOnce = false;

    //   if(!window.doThisOnce){
    //     window.doThisOnce = true;

    //     console.log(`nmArr: `, JSON.stringify(nmArr, null, 2));
    //     console.log(`rowsNames: `, JSON.stringify(rowsNames, null, 2));
    //     console.log(`eachLineSofar: `, eachLineSofar);

    //   }
    // }

    if(rowsNames.length > 4){
      rowsNames = rowsNames.slice(0, 3);
    }

    if(rowsNames.length >= 1 && rowsNames.length <= 3) rowsNames = [...rowsNames, eachLineSofar];
    if(rowsNames.length === 0) rowsNames.push(nm);

    // if( n === '1'){

    //   if(typeof(window.doThisOnce) === 'undefined') window.doThisOnce = false;

    //   if(!window.doThisOnce){
    //     window.doThisOnce = true;

    //     console.log(`rowsNames: `, JSON.stringify(rowsNames, null, 2));
    //     console.log(`nmArr: `, JSON.stringify(nmArr, null, 2));

    //   }
    // }

    return rowsNames;
  }

export const buildNameLineArray = ({nm, n, isPedigree, width}) => {

  if(typeof(nm) === 'undefined' ) return {fullNameLineArr: [], fullNameLineArrWidth: []};

  // nm = '1234567890-1234567890 1234567890-1234567890 1234567890-1234567890 1234567890-1234567890';

  const debugFullName = false;
  const testNm = "Gottfried I von Metz und Dagsburg, III, Graf im Bliesgau";
  // const testN = 75400;

  let fullNameLineWidth = fullNameLineWidthDefaultTreeNormalFont;

  if(typeof(isPedigree) !== 'undefined' && isPedigree ) {
    fullNameLineWidth = fullNameLineWidthPedigreeTreeNormalFont;
  }

  if(dualPedigreeMode ) {
    fullNameLineWidth = fullNameLineWidthDualPedigreeTreeNormalFont;
  }

  if( typeof(width) !== 'undefined') {
    fullNameLineWidth = width;
  }

  let nmArray = [];
  if(isAsianStr(nm)){
    nmArray[0] = nm.substring(0, 8);
    nmArray[1] = nm.substring(8, 99999999);
  } else{
    nmArray = nm.split(" ");
  }
  const fontSize = fullNameFontSize;
  const fontStyle = fullNameFontStyle;
  const lineHeight = fullNameLineHeight;

  let _fullNameLineArr = [];
  let fullNameLineArr = [];
  let fullNameLineArrWidth = [];
  let eachLineSofar = '';
  let remainingStr = '';
  let soFarLength = 0;
  let accumLength = 0;
  let divider = undefined;

  if (debugFullName && nm === testNm) {
    console.log(`nmArray: `, JSON.stringify(nmArray, null, 2));
    console.log(`{}: `, JSON.stringify({
          fontSize,
          fontFamily,
          fontStyle,
          lineHeight,
        }, null, 2));
  }

  // const arrayOfWidth =

  nmArray.map((fullNamePartial, idx) =>{

    let fullnamePartialTest = new Konva.Text({
          x: 0,
          y: 0,
          text: fullNamePartial + ' ',
          fontSize,
          fontFamily,
          fontStyle,
          lineHeight,
          align: 'left'
        });

    let fullNamePartialWidth = fullnamePartialTest.width();



/*
    if (fullNamePartialWidth > fullNameLineWidth) {

      fullNamePartial = fullNamePartial.substring(0, 11) + '...';
      fullnamePartialTest = new Konva.Text({
            x: 0,
            y: 0,
            text: fullNamePartial + ' ',
            fontSize,
            fontFamily,
            fontStyle,
            lineHeight,
            align: 'left'
          });
      fullNamePartialWidth = fullnamePartialTest.width();
    }
*/
    soFarLength += fullNamePartialWidth;
    accumLength += fullNamePartialWidth;
    // if (debugFullName && nm === testNm)  console.log(`fullNamePartial: `, fullNamePartial, ' fullNamePartialWidth: ', fullNamePartialWidth);
    if( soFarLength >= fullNameLineWidth ) {
      if (debugFullName && nm === testNm) {
        console.log(`B) soFarLength: `, soFarLength, ` vs. fullNameLineWidth: `, fullNameLineWidth, ` fullNamePartial: `, fullNamePartial);
        console.log(`eachLineSofar: `, eachLineSofar);
      }
      if(eachLineSofar !== ''){
        if (debugFullName && nm === testNm)  console.log(`pushing: `, eachLineSofar.trim());
        _fullNameLineArr.push(eachLineSofar.trim());
        fullNameLineArrWidth.push(soFarLength);
      }
      divider = '---------------';
      soFarLength = fullNamePartialWidth;
      eachLineSofar = '';
    } else{
      if (debugFullName && nm === testNm) {
        console.log(`A) soFarLength: `, soFarLength, ` vs. fullNameLineWidth: `, fullNameLineWidth, ` fullNamePartial: `, fullNamePartial);
      }
      divider = undefined;
    }
    eachLineSofar += fullNamePartial + ' ';
    remainingStr = fullNamePartial;

    return {
      fullNamePartial,
      __fullNameLineArr: [..._fullNameLineArr],
      remainingStr,
      soFarLength,
      accumLength,
      fullNameLineWidth,
      divider,
      idx,
      fullNamePartialWidth,
      height: fullnamePartialTest.height(),
    };
  })


  if (debugFullName && nm === testNm)  {
    // console.log(`arrayOfWidth: `, JSON.stringify(arrayOfWidth, null, 2));
    console.log(`nm: `, nm);
    console.log(`_fullNameLineArr: `, JSON.stringify(_fullNameLineArr, null, 2));
    console.log(`remainingStr: `, remainingStr);
    console.log(`eachLineSofar: `, eachLineSofar);
  }

  if(!_fullNameLineArr.length){
    fullNameLineArr.push(nm);
    fullNameLineArrWidth.push(soFarLength);
  } else if(
    nmArray.length >= 2 && _fullNameLineArr.length >= 1
  ){
    fullNameLineArr = [..._fullNameLineArr, eachLineSofar];
    fullNameLineArrWidth.push(soFarLength);

    if (debugFullName && nm === testNm) {
      console.log('C -------------------------------------');
      console.log(`nmArray: `, JSON.stringify(nmArray, null, 2));
      console.log(`remainingStr: `, remainingStr);
      console.log(`_fullNameLineArr: `, JSON.stringify(_fullNameLineArr, null, 2));
      console.log(`fullNameLineArr: `, JSON.stringify(fullNameLineArr, null, 2));
      console.log(`fullNameLineArr[1]: `, fullNameLineArr[1]);
      console.log(`fullNameLineArr[2]: `, fullNameLineArr[2]);
      console.log(`fullNameLineArr[3]: `, fullNameLineArr[3]);
      console.log(`fullNameLineArr[4]: `, fullNameLineArr[4]);
    }

  }

  if(fullNameLineArr.length > 4){
    fullNameLineArr = fullNameLineArr.slice(0, 4)
  }

  if (debugFullName && nm === testNm) {
    // console.log(`fullNameLineArr: `, JSON.stringify(fullNameLineArr, null, 2));
  }

  return {fullNameLineArr, fullNameLineArrWidth};
}

export const howThisChoiceSpouseWouldBeCalled = (gender) => {

    let what = null;

    if(gender === 'f') {
      what = 'husband';
    }
    else if(gender === 'm'){
      what = 'wife';
    }

    return what;

}

export const howThisChoiceParentWouldBeCalled = (gender) => {

    let what = null;

    if(gender === 'm') {
      what = 'mother';
    }
    else if(gender === 'f'){
      what = 'father';
    }

    return what;

}

export const howThisSpouseWouldBeCalled = (gender) => {

    const addHusband = shrinkWordsWidth({word: toUpper(translatedLabels['Add husband'].translatedLabel), maxLength: 30});
    const addWife = shrinkWordsWidth({word: toUpper(translatedLabels['Add wife'].translatedLabel), maxLength: 30});
    const addSpouse = shrinkWordsWidth({word: toUpper(translatedLabels['Add spouse'].translatedLabel), maxLength: 30});

    let what = null;

    if(gender === 'f') {
      what = addHusband;
    }
    else if(gender === 'm'){
      what = addWife;
    } else {
      what = addSpouse;
    }

    return what;

}
export const countValueInObj = ({obj, str}) => {

  let count = 0;

  for( let key in obj){
    if(obj[key] === str) count++;
  }

  return count;

}

export const howThisParentWouldBeCalled = (gender) => {

    const addMother = shrinkWordsWidth({word: toUpper(translatedLabels['Add mother'].translatedLabel), maxLength: 30});
    const addFather = shrinkWordsWidth({word: toUpper(translatedLabels['Add father'].translatedLabel), maxLength: 30});
    const addPerson = shrinkWordsWidth({word: toUpper(translatedLabels['Add person'].translatedLabel), maxLength: 30});

    let what = null;

    if(gender === 'm') {
      what = addMother;
    }
    else if(gender === 'f'){
      what = addFather;
    } else {
      what = addPerson;
    }

    return what;

}

export const howThisNonAddableGhostWouldBeCalled = (gender) => {

    const mother = shrinkWordsWidth({word: toUpper(translatedLabels['mother'].translatedLabel), maxLength: 30});
    const father = shrinkWordsWidth({word: toUpper(translatedLabels['father'].translatedLabel), maxLength: 30});
    const person = shrinkWordsWidth({word: toUpper(translatedLabels['person'].translatedLabel), maxLength: 30});

    let what = null;

    if(gender === 'm') {
      what = mother;
    }
    else if(gender === 'f'){
      what = father;
    } else {
      what = person;
    }

    return what;

}

export const getCanvasVars = (nodes) => {
  const realXCoord = Math.abs(Math.min(...nodes.map((coor) => {
    return ( typeof(coor.x) !== 'undefined' ? coor.x : 0);
  })));
  const realYCoord = Math.abs(Math.max(...nodes.map((coor) => {
    return ( typeof(coor.y) !== 'undefined' ? coor.y : 0);
  })));
  return {
    realXCoord,
    realYCoord,
  };
};

export const buildDateAliveText = ({dob_c, dod_c, dob_y, dod_y, l}) => {

  if(typeof(dob_y) === 'undefined' && typeof(dod_y) === 'undefined') return '';

  const deathTranslated = ( !isDevelopment ? window.trl('d.', 'Abbreviation for died'): 'd.')
  const circaTranslated = ( !isDevelopment ? window.trl('c.', 'Abbreviation for circa'): 'c.')
  const birthTranslated = ( !isDevelopment ? window.trl('b.', 'Abbreviation for born'): 'b.')

  const dead = ( typeof(l) !== 'undefined' && l === 1 ? '' : ` ${deathTranslated}`);

  const circaFromLabel = (dob_c === 1 ? `${circaTranslated}`: '');
  const yearBorn = (typeof(dob_y) === 'undefined' ? `${birthTranslated}`: dob_y);
  const circaToLabel = (dod_c === 1 ? ` - ${circaTranslated}`: ' - ');
  const yearDied = (typeof(dod_y) === 'undefined' ? dead: dod_y);

  const dateAliveText = `(${circaFromLabel}${yearBorn}${circaToLabel}${yearDied})`;

  return dateAliveText;
}

export const derivePhotoBorderColor = ({c, mp, sh}) => {

  var color;

  if(typeof(c) !== 'undefined' && c === 1) {
    color = '#51B4ED';

  } else if(typeof(mp) !== 'undefined' && mp === 1){
    color = 'purple';

  } else if(typeof(sh) !== 'undefined' && sh === 1){
    color = '#79CE03';
  }
  else{
    color = 'grey';
  }
  return color;

}


export const buildImgStyleObjBasedOnOrientation = ({nodeObj}) => {

  if(typeof(nodeObj) === 'undefined') return;

  let styleObj = {};

  const cropStartY = ((nodeObj.img.height - nodeObj.img.width) / 3);

  if(nodeObj.img.width > nodeObj.img.height){ // Landscape

    const magnification = Math.ceil(( nodeObj.img.width / nodeObj.img.height ) * 100);

    styleObj = {
      backgroundSize: `${magnification}%`,
      backgroundPosition: `center`,
    }

  } else { // Portrait

    styleObj = {
      backgroundSize: 'cover',
      backgroundPosition: `center -${cropStartY}px`,
    }
  }

  styleObj = {...styleObj, backgroundImage: `url(${nodeObj.img.src})`,};

  return styleObj

}

const getUnionObjWithChildIncluded = ({child, unions}) => {
  return unions.filter((union)=>{
    return union.c && union.c.includes(child) && typeof(union.p) !== 'undefined';
  })
}

const getUnionArrayThatIncludesThisPartner = ({partner, unions}) => {
  return unions.filter((union)=>{
    return union.p && union.p.includes(partner);
  })
}


const buildPedigreePlaceHolderNodeObj = ({node, nodeObjs, coord}) => {

  nodeObjs[node] = {
    n: node,
    // nt: 'ghost',
    // a: true,
    nm: '...',
    fullNameLineArr: [''],
    img: {
      'type': 'placeholder',
      'src': '/canvas-tree/imgs/no_photo_u.gif'
    },
    g: 'u',
    photoBorderColor: 'grey',
    isPedigreePlaceHolder: true,
  }
  nodeObjs[node] = {
    ...nodeObjs[node],
    ...coord,
  }

  return nodeObjs;
}

const getAncestors = ({ children,
                        nodeObjs,
                        unions,
                        ancestors,
                        pedigreeGhostNodeId,
                        generation,
                        maxGenerations
                      }) => {

  generation++;
  if(generation >= maxGenerations) return ancestors;

  // console.log(`children: `, JSON.stringify(children, null, 2));

  const isSingleFatherParent = () => {
    return children[1] === undefined &&
    typeof(children[0]) !== 'undefined' &&
    typeof(nodeObjs[children[0]]) !== 'undefined' &&
    nodeObjs[children[0]].g === 'm'
  }

  if(isSingleFatherParent()){
    children.reverse();
  }

  // console.log(`isSingleFatherParent(): `, isSingleFatherParent());

  // console.log(`children[0]: `, children[0]);
  // if(typeof(children[0]) !== 'undefined' && typeof(nodeObjs[children[0]]) !== 'undefined') console.log(`nodeObjs[children[0]].g: `, nodeObjs[children[0]].g);

  children.forEach((child, idx)=>{
    if(getUnionObjWithChildIncluded({child, unions}).length > 0){
      const partnerIds = getUnionObjWithChildIncluded({child, unions})[0].p;

      // console.log(`partnerIds: `, JSON.stringify(partnerIds, null, 2));

      if(partnerIds[0] && partnerIds[1]){
        ancestors.push(partnerIds[1])
        ancestors.push(partnerIds[0])
      }

      // if( maxGenerations === 3 && idx === 1) {
      //   console.log(`partnerIds: `, JSON.stringify(partnerIds, null, 2));
      //   console.log(`nodeObjs[partnerIds[0]].g: `, nodeObjs[partnerIds[0]].g);
      //   console.log(`partnerIds[1]: `, partnerIds[1]);
      // }
      if(partnerIds[0] && nodeObjs[partnerIds[0]].g === 'f' && !partnerIds[1]){
        ancestors.push(partnerIds[0])
        pedigreeGhostNodeId--;
        ancestors.push(pedigreeGhostNodeId);
      }

      // if( maxGenerations === 3 && idx === 1) console.log(`ancestors: `, JSON.stringify(ancestors, null, 2));

      if(partnerIds[0] && nodeObjs[partnerIds[0]].g === 'm' && !partnerIds[1]){
        pedigreeGhostNodeId--;
        ancestors.push(pedigreeGhostNodeId);
        ancestors.push(partnerIds[0])
      }

      if(partnerIds[0] && nodeObjs[partnerIds[0]].g === 'u' && !partnerIds[1]){
        ancestors.push(partnerIds[0])
        pedigreeGhostNodeId--;
        ancestors.push(pedigreeGhostNodeId);
      }

      if(partnerIds[0] && typeof(nodeObjs[partnerIds[0]].g) === 'undefined'  && !partnerIds[1]){
        ancestors.push(partnerIds[0])
        pedigreeGhostNodeId--;
        ancestors.push(pedigreeGhostNodeId);
      }

      if(partnerIds.length > 0) {
        const childrenIn = ( typeof(partnerIds[1]) === 'undefined' ? [partnerIds[0], undefined]: [partnerIds[1], partnerIds[0]]);
        ancestors = [...getAncestors({
          children: childrenIn,
          nodeObjs,
          unions,
          ancestors,
          pedigreeGhostNodeId,
          generation,
          maxGenerations})];
      }

    } else {
      pedigreeGhostNodeId--;
      ancestors.push(pedigreeGhostNodeId);
      pedigreeGhostNodeId--;
      ancestors.push(pedigreeGhostNodeId);
    }
  })
  return ancestors;
}

const buildIdpsFromThisBranch = ({branchObj, ancestorialIdpsOfBranch}) => {
  for( const key in branchObj){
    ancestorialIdpsOfBranch.push(key);
    ancestorialIdpsOfBranch = [...buildIdpsFromThisBranch({branchObj: branchObj[key], ancestorialIdpsOfBranch})];
  }
  return ancestorialIdpsOfBranch;
}

const buildArrayOfIdpAncestorsFromThisIdp = ({idp, branchObj, ancestorialIdpsOfBranch}) => {
  for( const key in branchObj){
    // console.log(`branchObj[key]: `, JSON.stringify(branchObj[key], null, 2));
    if(idp === key) {
      // console.log(` -- `, JSON.stringify({idp, key}, null, 2));
      // console.log(`branchObj: `, JSON.stringify(branchObj, null, 2));
      // console.log(`branchObj[key]: `, JSON.stringify(branchObj[key], null, 2));
      ancestorialIdpsOfBranch = [...buildIdpsFromThisBranch({branchObj: branchObj[key], ancestorialIdpsOfBranch})];
    }
    ancestorialIdpsOfBranch = [...buildArrayOfIdpAncestorsFromThisIdp({idp, branchObj: branchObj[key], ancestorialIdpsOfBranch})];
  }
  return ancestorialIdpsOfBranch;
}

const idpInMiniTrees = ({idp, miniTreeArrays}) => {
  let boolResult = false;
  miniTreeArrays.forEach((miniTreeArray)=>{
    if(miniTreeArray.includes(idp)) boolResult = true;
  })
 return boolResult;
}

const createPlaceHoldersForFocusWithNoAncestors = ({ancestors}) => {
  if(ancestors.length < 30){
    for( let i =  ancestors.length; i <= 30; i++){
      ancestors.push((i * -1));
    }
  }
 return ancestors;
}

const getParentStemIdpFromChildTwigIdp = ({idp, branchObj, idpParentsArr, prevKey}) => {
  for( const key in branchObj){
    if(idp.toString() === key) idpParentsArr.push(prevKey);
    getParentStemIdpFromChildTwigIdp({idp, branchObj: branchObj[key], idpParentsArr, prevKey: key});
  }
  return {idpParentsArr};
}

const idpPartnerLookup = {
    3: 2,
    2: 3,
    7: 6,
    6: 7,
    15: 14,
    14: 15,
    31: 30,
    30: 31,
    29: 28,
    28: 29,
    13: 12,
    12: 13,
    27: 26,
    26: 27,
    25: 24,
    24: 25,
    5: 4,
    4: 5,
    11: 10,
    10: 11,
    9: 8,
    8: 9,
    23: 22,
    22: 23,
    21: 20,
    20: 21,
    19: 18,
    18: 19,
    17: 16,
    16: 17,
  }

export const setGenderForGhostNodes = ({nodeObjs}) => {

  const getPartnerGender = ({idp}) => {
    let partnerGender = undefined;
    const partnerIdp = idpPartnerLookup[idp];
    for( const node in nodeObjs ){
      if(nodeObjs[node].idp === partnerIdp) {
        if(parseInt(node, 10) > 0) {
          partnerGender = nodeObjs[node].g;
        } else{
          partnerGender = undefined;
        }
      }
    }
    return partnerGender;
  }

  for( const node in nodeObjs ){
    if(nodeObjs[node].pedigreeGhostMale || nodeObjs[node].pedigreeGhostFemale ) {

      nodeObjs[node].g = (nodeObjs[node].pedigreeGhostMale === true ? 'm': 'f');
      nodeObjs[node].g = (nodeObjs[node].pedigreeGhostFemale  === true ? 'f': nodeObjs[node].g);

      if(typeof(getPartnerGender({idp: nodeObjs[node].idp}) !== 'undefined')){
        nodeObjs[node].g = (getPartnerGender({idp: nodeObjs[node].idp}) === 'u' ? 'u': nodeObjs[node].g);
      }

    }
  }

  return nodeObjs;
}

export const addPedigreeCoordinates = ({
  nodeObjs,
  unions,
  focusPrId,
  isDualPedigree,
  dualPedigreeFocusRoot,
  side,
  dualPedigreeObj,
}) => {

  let branches = [];
  const dualPedigreeCenter = 330;
  let titleName = 'A Private Family';

  let childrenLimit = 5;
  let tooManyToFitChart = 9;
  let onlyKeepThisManyChildren = parseInt(urlGet('keep'), 10) || tooManyToFitChart;
  let childrenNodesArray = [];
  if(typeof(unions) !== 'undefined' && typeof(unions[0]) !== 'undefined' && typeof(unions[0].c) !== 'undefined'){

    if( side === 'left'  ) {

      // console.log(`%c unions[0].c:> ${unions[0].c}`, [
      // 'color: white',
      // 'background: brown',
      // 'font-size: 14px',
      // 'border: 5px solid brown',
      // 'padding: 10px',
      // ].join(';'));

    }

    childrenNodesArray = unions[0].c;
    childrenNodesArray = childrenNodesArray.filter((value, idx)=>{
      return idx < onlyKeepThisManyChildren;
    });
  }

  let numChildren = childrenNodesArray.length;

  const shiftObj = {
    5: -20,
    6: -45,
    7: -80,
    8: -120,
    9: 10,
    10: 30,
  }

  let shiftUpIfMoreThan5ChildrenFormula =  - ( numChildren >= childrenLimit ? shiftObj[numChildren]: 0);
  shiftUpIfMoreThan5ChildrenFormula =  - ( numChildren >= tooManyToFitChart ? shiftObj[numChildren]: shiftUpIfMoreThan5ChildrenFormula);

  if(isDualPedigree){

    const xPoint = dualPedigreeCenter;
    const collarStart = 184
    const collarEnd = 217


    /*

      Title

     */

    const titleYStart = 10;
    const nodeRight = dualPedigreeFocusRoot['right'];
    const nodeLeft = dualPedigreeFocusRoot['left'];
    if( side === 'right'  ){
      branches.push({
        node: dualPedigreeFocusRoot['right'],
        nodeRight,
        nodeLeft,
        segment: 'unionTitle',
        left: xPoint,
        top: titleYStart,
      })
    }

    let rightName = undefined;
    if( typeof(nodeObjs[nodeRight]) !== 'undefined' ){
      rightName = ( typeof(nodeObjs[nodeRight].mdn) !== 'undefined' ?
        nodeObjs[nodeRight].mdn:
        nodeObjs[nodeRight].ln);
      // if(typeof(nodeObjs[nodeRight].mdn) === 'undefined' && typeof(nodeObjs[nodeRight].ln) === 'undefined') rightName = '<blank>';
    }
    let leftName = nodeObjs[nodeLeft].ln;
    // if( typeof(nodeObjs[nodeLeft].ln) === 'undefined' ) leftName = '<blank>';

    if (typeof(rightName) !== 'undefined' && typeof(leftName) !== 'undefined') {
      titleName = `The ${leftName}-${rightName} Family`;
    } else if (typeof(leftName) === 'undefined') {
      titleName = `The ${rightName} Family`;
    } else if (typeof(rightName) === 'undefined') {
      titleName = `The ${leftName} Family`;
    }

    if (typeof(rightName) === 'undefined' && typeof(leftName) === 'undefined') {
      titleName = 'Private Family';
    }

    titleName = decodeURIComponent(decodeURI(titleName));

    if( side === 'left'){

      /*

        BORDER

       */

      branches.push({
        node: dualPedigreeFocusRoot['right'],
        nodeRight: dualPedigreeFocusRoot['right'],
        nodeLeft: dualPedigreeFocusRoot['left'],
        segment: 'unionBorderSvg',
        left: xPoint,
        top: titleYStart + 15,
      })

      branches.push({
        node: dualPedigreeFocusRoot['right'],
        nodeRight: dualPedigreeFocusRoot['right'],
        nodeLeft: dualPedigreeFocusRoot['left'],
        segment: 'unionBorderSvg',
        left: xPoint,
        top: titleYStart - 3,
        scale: -1,
      })

      /*

        FOCUS ROOT BAR

       */

      branches.push({
        focusRootSide: 'left',
        node: dualPedigreeFocusRoot['left'],
        segment: 'stem',
        stemStart: xPoint - 10,
        stemEnd:  xPoint + 10,
        sideYPoint: collarStart + shiftUpIfMoreThan5ChildrenFormula,
      });

      /*

        CHILDREN

       */

      if( typeof(childrenNodesArray) !== 'undefined'){

        childrenNodesArray.forEach((childNode, idx)=>{

          /*

            FOCUS ROOT COLLAR

           */

          if( idx === 0){
            branches.push({
              node: childNode,
              collarStart: collarStart + shiftUpIfMoreThan5ChildrenFormula,
              xPoint,
              segment: 'collar',
              collarEnd: collarEnd + shiftUpIfMoreThan5ChildrenFormula,
              isFocusRootCollar: true,
            })
          }

          const childrenTopCeiling = collarEnd  + shiftUpIfMoreThan5ChildrenFormula;
          const verticalSpacing = 40;
          const top = childrenTopCeiling + (verticalSpacing * idx);
          const singleChildTop = childrenTopCeiling;
          nodeObjs[childNode] = {...nodeObjs[childNode],...{
            top: ( numChildren >= tooManyToFitChart ? top - 10 - (idx * 18) :  top),
            singleChildTop,
            right: 395,
            bottom: 105,
            left: dualPedigreeCenter - ( numChildren >= tooManyToFitChart ? 90:  70),
            isPedigree: true,
            isChildrenOfDualPedFocusUnion: true,
            side: 'middle',
            oneOfTooMany: ( numChildren >= tooManyToFitChart ? true:  false)
          }};
        });
      }
    }
  }

  const pedigreeLayoutTree = {
    3: {
      7: {
        15: {
          31: null,
          30: null,
        },
        14: {
          29: null,
          28: null,
        }
      },
      6: {
        13: {
          27: null,
          26: null,
        },
        12: {
          25: null,
          24: null,
        }
      },
    },
    2: {
      5: {
        11: {
          23: null,
          22: null,
        },
        10: {
          21: null,
          20: null,
        }
      },
      4: {
        9: {
          19: null,
          18: null,
        },
        8: {
          17: null,
          16: null,
        }
      },
    },
  }

  const idpNodeObj = {};
  let ancestors = [];
  let pedigreeGhostNodeId = 0;

  let focusNodeId = null;
  if( isDualPedigree ){
    focusNodeId = dualPedigreeFocusRoot[side];
  } else {
    focusNodeId = parseInt(getNodeFromNodeObjsWithPrId({nodeObjs, prId: focusPrId, fromWhere: 'addPedigreeCoordinates'}), 10);
  }

  ancestors.push(focusNodeId)
  ancestors = getAncestors({children:[focusNodeId], nodeObjs, unions, ancestors, pedigreeGhostNodeId, generation: 0, maxGenerations: 3});
  // let pedigreeParentNodeIds = ancestors.slice(1, 3);
  let grandParentNodeIds = ancestors.slice((ancestors.length - 4), ancestors.length);
  grandParentNodeIds.forEach((grandParentId, idx)=>{
    pedigreeGhostNodeId = ( Math.min(...ancestors) < 0 ? Math.min(...ancestors) : 0);
    ancestors = getAncestors({children: [grandParentId], nodeObjs, unions, ancestors, pedigreeGhostNodeId, generation: 0, maxGenerations: 2});
  })
  let greatGrandParentNodeIds = ancestors.slice((ancestors.length - 8), ancestors.length);
  greatGrandParentNodeIds.forEach((greatGrandParentId, idx)=>{
    pedigreeGhostNodeId = ( Math.min(...ancestors) < 0 ? Math.min(...ancestors) : 0);
    ancestors = getAncestors({children: [greatGrandParentId], nodeObjs, unions, ancestors, pedigreeGhostNodeId, generation: 0, maxGenerations: 2});
  })

  // let secondGreatGrandParentNodeIds = ancestors.slice((ancestors.length - 16), ancestors.length);
  // console.log(`pedigreeParentNodeIds: `, JSON.stringify(pedigreeParentNodeIds, null, 2));
  // console.log(`grandParentNodeIds: `, JSON.stringify(grandParentNodeIds, null, 2));
  // console.log(`greatGrandParentNodeIds: `, JSON.stringify(greatGrandParentNodeIds, null, 2));
  // console.log(`secondGreatGrandParentNodeIds: `, JSON.stringify(secondGreatGrandParentNodeIds, null, 2));
  // console.log(`ancestors: `, JSON.stringify(ancestors, null, 2));
  // const namesAn = ancestors.map((ancestor)=>{
  //   return parseInt(nodeObjs[ancestor].fn, 10);
  // })
  // console.log(`namesAn: `, JSON.stringify(namesAn, null, 2));
  //   ancestors = [];
  //   let countPed; = 0;
  //   for( const key in nodeObjs ){
  //     countPed = countPed + 1;
  //     if(countPed < 32) ancestors.push(key);
  //   }

  ancestors = createPlaceHoldersForFocusWithNoAncestors({ancestors});

  ancestors = ancestors.map((ancestor)=>{
    return ancestor.toString();
  });

  if( isDualPedigree ) ancestors.length = 15;

  let idp = 0;
  let verticalSpacing = 0;
  let _x = 0;

  if( isDualPedigree ){
    _x = ( side === 'left' ? dualPedigreeCenter + 10: dualPedigreeCenter - 75);
  } else {
    _x = 0;
  }

  let _y = 0;

  const shiftUp = 50;

  const distNodes = {
    0: {idp: 1, top: (shiftUp - 211),  verticalSpacing: 0},
    1: {idp: 2, top: (shiftUp - 442),  verticalSpacing: 155},
    2: {idp: 4, top: (shiftUp - 407),  verticalSpacing: 79},
    3: {idp: 8, top: (shiftUp - 390),  verticalSpacing: 40},
    4: {idp: 16, top: (shiftUp - 383), verticalSpacing: 20},
  }

  let stemIdps = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
  const parentsIdps = [ 2, 3,]; // parents
  const gpIdps = [ 4, 5, 6, 7]; // grandparents
  const ggpIdps = [ 8, 9, 10, 11, 12, 13, 14, 15]; // greatgrandparents
  // const ggpPaternalIdps = [ 12, 13, 14, 15]; // paternal greatgrandparents
  // const ggpMaternalIdps = [ 8, 9, 10, 11,]; // paternal greatgrandparents
  const gggpIdps = [ 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]; // greatgreatgrandparents
  const collarGpIdps = [5, 7]; // collar grandparents
  const collarGgpIdps = [ 9, 11, 13, 15]; // collar greatgrandparents
  const collarGggpIdps = [ 17, 19, 21, 23, 25, 27, 29, 31]; // collar greatgreatgrandparents
  const splitShiftUpArray = [3 , 6, 12, 24];
  const splitShiftDownArray = [2 ,4, 8, 16];
  const maleIdps = [3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31];
  const femaleIdps = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30];

  let miniTreeArrays = [];

  // console.log(`ancestors: `, JSON.stringify(ancestors, null, 2));

  ancestors.forEach((node) =>{

    const halfwidth = nodeWidth/2;
    const halfheight = nodeHeight/2;

    let left = undefined;
    let top  = undefined;
    let origTop  = undefined;
    let right = undefined;
    let bottom = undefined;
    let xCenter = undefined;
    let sidePoint = undefined;
    let testColor = undefined;

    let shiftSplitSpacing = 0;
    idp++;
    idpNodeObj[idp] = node;
    for( let key in distNodes){
      if(idp === distNodes[key].idp){
        verticalSpacing = distNodes[key].verticalSpacing
        if ( isDualPedigree ){
          if( side === 'left' ){
            _x -= ( idp === 2 ? 20: 85);
          } else {
            _x += ( idp === 2 ? 20: 85);
          }
        } else {
          _x += ( idp === 2 ? 20: 85);
        }
        _y = (-1 * distNodes[key].top);
      }
      if(splitShiftUpArray.indexOf(idp) > -1){
        shiftSplitSpacing = ( isDualPedigree ? 60: 10);
      }
      if(splitShiftDownArray.indexOf(idp) > -1){
        shiftSplitSpacing = ( isDualPedigree ? -50: -3);
      }
    }
    _y -= verticalSpacing + shiftSplitSpacing;
    if( isDualPedigree ){
      if( [1].indexOf(idp) > -1){
        origTop = _y;
        _y = _y  + shiftUpIfMoreThan5ChildrenFormula;
       // testColor = 'orange';  // Book Dualpeded vertical center
      }
      if( [3].indexOf(idp) > -1){
        _y -= 3;
        // testColor = 'blue';
      }
      if( [2].indexOf(idp) > -1){
        _y += 5;
        // testColor = 'red';
      }
      if( [5].indexOf(idp) > -1){
        _y -= 26;
        // testColor = 'blue';
      }
      if( [7,].indexOf(idp) > -1){
        _y -= 30;
        // testColor = 'blue';
      }
      if( [4].indexOf(idp) > -1){
        _y += 20;
        // testColor = 'red';
      }
      if( [6,].indexOf(idp) > -1){
        _y += 27;
        // testColor = 'red';
      }
  }
    shiftSplitSpacing = 0;

    left = _x;
    top = _y;
    right = _x + nodeWidth;
    bottom = _y + nodeHeight;
    xCenter = _x + halfwidth;
    sidePoint = _y + halfheight;

    let coord = {
      isPedigree: true,
      idp,
      top,
      origTop,
      right,
      bottom,
      left,
      xCenter,
      sideYPoints : [sidePoint],
      sideYpointIdx: 0,
      testColor,
      side: ( typeof(side) !== 'undefined' ? side: undefined ), // For dualpedigree.. which side of butterfly chart
    }

    if([1, ...parentsIdps, ...gpIdps, ...ggpIdps].indexOf(idp) > -1){
      coord = {...coord, pedigreeIsTall: true}
    }

    if([...ggpIdps].indexOf(idp) > -1){
      coord = {...coord, isGGP: true};
    }

    if (typeof(nodeObjs[node]) === 'undefined') {

      const idpAsString = idp.toString();
      let ancestorialIdpsOfBranch = buildArrayOfIdpAncestorsFromThisIdp({idp: idpAsString, branchObj: pedigreeLayoutTree, ancestorialIdpsOfBranch: []});

      if(!idpInMiniTrees({idp: idpAsString, miniTreeArrays})){
        miniTreeArrays.push(ancestorialIdpsOfBranch);
        coord['isPedigreeGhost'] = true;
        coord['pedigreeGhostAddLabel'] = true;
        coord['pedigreeGhostMale'] = maleIdps.includes(idp);
        coord['pedigreeGhostFemale'] = femaleIdps.includes(idp);
        const idpParent = getParentStemIdpFromChildTwigIdp({idp, branchObj: pedigreeLayoutTree, idpParentsArr: [], prevKey:1}).idpParentsArr[0];
        const pedigreeParentNodeId = idpNodeObj[idpParent];
        coord['pedigreeParentNodeId'] = pedigreeParentNodeId;
        // coord['nt'] = 'ghost';
      }

      nodeObjs = buildPedigreePlaceHolderNodeObj({node, nodeObjs, coord});

    } else {
      nodeObjs[node] = {
        ...nodeObjs[node],
        ...coord,
      }
    }



    /*

        --------------------------- BRANCHES -----------------------------------

     */

    let singleParentNodeId = undefined;
    if(isDualPedigree) {

      let partnerNode = undefined;
      const arrayIncludingThisPartner  = getUnionArrayThatIncludesThisPartner({partner: node, unions});
      if( arrayIncludingThisPartner.length > 0 ){
        const partnerArray = arrayIncludingThisPartner[0].p;
        if( typeof(partnerArray) !== 'undefined'  ) {
          partnerArray.forEach((partner)=>{
            if(partner !== node) partnerNode = partner;
          })
        }
      }

      const parentNodeIds = getUnionObjWithChildIncluded({child: parseInt(node, 10), unions});
      const hasParents = parentNodeIds.length > 0;
      const hasOnlyOneParent = hasParents && parentNodeIds[0].p.length === 1
      if( hasParents && hasOnlyOneParent){
        singleParentNodeId = parentNodeIds[0].p[0];
      }
      const hasOnlyOneParentFather = hasParents && hasOnlyOneParent && typeof(nodeObjs[singleParentNodeId].g) !== 'undefined' && nodeObjs[singleParentNodeId].g === 'm';
      const hasOnlyOneParentMother = hasParents && hasOnlyOneParent && typeof(nodeObjs[singleParentNodeId].g) !== 'undefined' && nodeObjs[singleParentNodeId].g === 'f';
      const hasOnlyOneUngenderedParent = hasParents && hasOnlyOneParent && typeof(nodeObjs[singleParentNodeId].g) !== 'undefined' && nodeObjs[singleParentNodeId].g === 'u';

      nodeObjs[node] = {
        ...nodeObjs[node],
        singleParentNodeId,
        hasParents,
        hasOnlyOneParent,
        hasOnlyOneParentFather,
        hasOnlyOneParentMother,
        hasOnlyOneUngenderedParent,
        partnerNode
      }
    }

    let xPoint = null;

    if( !isDualPedigree){
      xPoint = left - 7;
    } else if(isDualPedigree && side === 'right'){
      left += widenDualPedigreeBranchesBy;
      right += widenDualPedigreeBranchesBy;
      xPoint = left - 7;
      top += 8;
      left += 9;
      right += 9;
      xPoint += 9;

          if([...gpIdps].indexOf(idp) > -1){
            top -= 0;
          }

              if([...ggpIdps].indexOf(idp) > -1){
                top -= 10;
                xPoint += 5;
                left += 5;
              }


    } else if(isDualPedigree && side === 'left'){
      left -= widenDualPedigreeBranchesBy;
      right -= widenDualPedigreeBranchesBy;
      xPoint = left + 53;
      left += 53;
      right -= 102;
      top += 8;

          if([...gpIdps].indexOf(idp) > -1){
            top -= 0;
            right -= 13;
          }

              if([...ggpIdps].indexOf(idp) > -1){
                top -= 10;
                xPoint = left - 14;
                left -= 14;
              }

    }


/*

      COLLAR PEDIGREE **********************************************

 */


    if( !isDualPedigree){

      if(idp === 3){

        branches.push({
          node,
          idp,
          collarStart: top + 10.5,
          xPoint,
          segment: 'collar',
          collarEnd: top + 175.5,
          singleParentNodeId
        })
      }

      if(collarGpIdps.indexOf(idp) > -1){

        nodeObjs[node].ancestorLevel = 1;
        branches.push({
          node,
          idp,
          collarStart: top + 10.5,
          xPoint,
          segment: 'collar',
          collarEnd: top + 89.5,
          singleParentNodeId
        })
      }

      if(collarGgpIdps.indexOf(idp) > -1){

        nodeObjs[node].ancestorLevel = 2;
        branches.push({
          node,
          idp,
          collarStart: top + 10.5,
          xPoint,
          segment: 'collar',
          collarEnd: top + 50.5,
          singleParentNodeId
        })
      }

      if(collarGggpIdps.indexOf(idp) > -1){

        nodeObjs[node].ancestorLevel = 3;
        branches.push({
          node,
          idp,
          collarStart: top + 7.5,
          xPoint,
          segment: 'collar',
          collarEnd: top + 27.5,
          singleParentNodeId
        })
      }

    } else if(isDualPedigree ){


/*

      COLLAR DUALPEDIGREE **********************************************

 */

      if([2, 3].indexOf(idp) > -1){  // Parents

        if( maleIdps.indexOf(idp) > -1){
          branches.push({
            node,
            idp,
            collarStart: top + 13.5,
            xPoint: xPoint + ( side === 'left'  ? -5: 14),
            segment: 'collar',
            collarEnd: top + 124,
            singleParentNodeId,
            onTopNode: true,
            // testColor: 'blue',
          })

        } else {

          branches.push({
            node,
            idp,
            collarStart: top - 102,
            xPoint: xPoint + ( side === 'left'  ? -5: 14),
            segment: 'collar',
            collarEnd: top + 14.5,
            singleParentNodeId,
            // testColor: 'red',
          })

        }

      }

      if(gpIdps.indexOf(idp) > -1){ //  GRAND PARENTS

        nodeObjs[node].ancestorLevel = 1;
        if( maleIdps.indexOf(idp) > -1){ //  GRAND FATHERS

           if( [ 5 ].indexOf(idp) > -1){

                branches.push({
                  node,
                  idp,
                  singleParentNodeId,
                  collarStart: top + 14.5,
                  xPoint: xPoint + ( side === 'left'  ? ( 20 - widenDualPedigreeBranchesBy): -( 10 - widenDualPedigreeBranchesBy)),
                  segment: 'collar',
                  collarEnd: top + 63.5,
                  onTopNode: true,
                  // testColor: 'orange',
                })


           }
           if( [ 7 ].indexOf(idp) > -1){

                branches.push({
                  node,
                  idp,
                  singleParentNodeId,
                  collarStart: top + 14.5,
                  xPoint: xPoint + ( side === 'left'  ? ( 20 - widenDualPedigreeBranchesBy): -( 10 - widenDualPedigreeBranchesBy)),
                  segment: 'collar',
                  collarEnd: top + 66.5,
                  onTopNode: true,
                  // testColor: 'brown',
                })
           }
        } else {


                             //  GRAND MOTHERS

          if( [ 4 ].indexOf(idp) > -1){
            branches.push({
              node,
              idp,
              singleParentNodeId,
              collarStart: top - 42.5,
              xPoint: xPoint + ( side === 'left' ? ( 20 - widenDualPedigreeBranchesBy): -( 10 - widenDualPedigreeBranchesBy)),
              segment: 'collar',
              collarEnd: top + 15.5,
              // testColor: 'green',
            })

          }
          if( [ 6 ].indexOf(idp) > -1){

            branches.push({
              node,
              idp,
              singleParentNodeId,
              collarStart: top - 43.5,
              xPoint: xPoint + ( side === 'left' ? ( 20 - widenDualPedigreeBranchesBy): -( 10 - widenDualPedigreeBranchesBy)),
              segment: 'collar',
              collarEnd: top + 15.5,
              // testColor: 'blue',
            })
          }
        }

      }

      if(ggpIdps.indexOf(idp) > -1){  //  GREAT GRAND PARENTS

        nodeObjs[node].ancestorLevel = 2;

        if( maleIdps.indexOf(idp) > -1){  //  GREAT GRAND FATHERS

          let customBranchObj = {}

          if( [9].indexOf(idp) > -1){
            customBranchObj = {
              // testColor: 'blue',
              collarStart: top + 37.5,
              collarEnd: top + 62.5,
            }
          }


          if( [13].indexOf(idp) > -1){
            customBranchObj = {
              // testColor: 'blue',
              collarStart: top + 37.5,
              collarEnd: top + 65.5,
            }
          }

          if( [11].indexOf(idp) > -1){
            customBranchObj = {
              // testColor: 'blue',
              collarStart: top + 10,
              collarEnd: top + 37.5,
            }
          }

          if( [15].indexOf(idp) > -1){
            customBranchObj = {
              // testColor: 'blue',
              collarStart: top + 10,
              collarEnd: top + 36.5,
            }
          }

          branches.push({
            node,
            idp,
            singleParentNodeId,
            onTopNode: true,
            xPoint: xPoint + ( side === 'left' ? ( 30 - widenDualPedigreeBranchesBy): -( 11 - widenDualPedigreeBranchesBy)),
            segment: 'collar',
            collarStart: top + 10.5,
            collarEnd: top + 30.5,
            ...customBranchObj
          })

        } else {
                              //  GREAT GRAND MOTHERS
          let customBranchObj = {}

          if( [8].indexOf(idp) > -1){
            customBranchObj = {
              // testColor: 'orange',
              collarStart: top + 21.5,
              collarEnd: top + 50.5,
            }
          }
          if( [12].indexOf(idp) > -1){
            customBranchObj = {
              // testColor: 'orange',
              collarStart: top + 24.5,
              collarEnd: top + 50.5,
            }
          }

          if( [14].indexOf(idp) > -1){
            customBranchObj = {
              // testColor: 'red',
              collarStart: top - 4.5,
              collarEnd: top + 22.5,
            }
          }

          if( [10].indexOf(idp) > -1){
            customBranchObj = {
              // testColor: 'green',
              collarStart: top - 3.5,
              collarEnd: top + 22.5,
            }
          }

          branches.push({
            node,
            idp,
            singleParentNodeId,
            xPoint: xPoint + ( side === 'left' ? (30 - widenDualPedigreeBranchesBy): -(11 - widenDualPedigreeBranchesBy)),
            segment: 'collar',
            collarStart: top - 9.5,
            collarEnd: top + 10.5,
            ...customBranchObj
          })

        }

      }

    }


/*

      TWIG AND STEM PEDIGREE ***********************************************

 */


    if( !isDualPedigree ){
      if([...parentsIdps, ...gpIdps, ...ggpIdps].indexOf(idp) > -1){
        branches.push({
          node,
          idp,
          segment: 'twig',
          twigStart: left - 7.2,
          twigEnd: left,
          sideYPoint: top + 10.5,
        })
      }

      if([...gggpIdps].indexOf(idp) > -1){
        nodeObjs[node].ancestorLevel = 4;
        branches.push({
          node,
          idp,
          segment: 'twig',
          twigStart: left - 7.2,
          twigEnd: left,
          sideYPoint: top + 7.5,
        })
      }

      if(stemIdps.indexOf(idp) > -1){
        branches.push({
          node,
          idp,
          segment: 'stem',
          stemStart: right,
          stemEnd: right + 8,
          sideYPoint: top + 10.5,
        })
      }

    } else if( isDualPedigree && typeof(side) !== 'undefined' && side === 'right') {

/*

      TWIG RIGHT DUALPEDIGREE ***********************************************

 */

        if([...parentsIdps, ...gpIdps, ...ggpIdps].indexOf(idp) > -1){

          let customBranchObj = {}

          if( [...parentsIdps].indexOf(idp) > -1){
            left += 14;
              customBranchObj = {
                // testColor: 'red',
                sideYPoint: top + 14,
              }
          }

          if( [...gpIdps].indexOf(idp) > -1){
            left -= (10 - widenDualPedigreeBranchesBy);
              customBranchObj = {
                sideYPoint: top + 15,
                // testColor: 'red',
              }
          }

          if( [...ggpIdps].indexOf(idp) > -1){
            left -= (11 - widenDualPedigreeBranchesBy);
            if( [14, 10].indexOf(idp) > -1){
              customBranchObj = {
                sideYPoint: top + 22,
                // testColor: 'red',
              }
            }
            if( [9, 13].indexOf(idp) > -1){
              customBranchObj = {
                sideYPoint: top + 38,
                // testColor: 'orange',
              }
            }
            if( [8, 12].indexOf(idp) > -1){
              customBranchObj = {
                sideYPoint: top + 50,
                // testColor: 'orange',
              }
            }
          }

          branches.push({
            node,
            idp,
            segment: 'twig',
            twigStart: left - 7.2,
            twigEnd: left + 2,
            sideYPoint: top + 10.5,
            ...customBranchObj
          })
        }

/*

      STEM RIGHT DUALPEDIGREE ******************************************************

 */

        if(stemIdps.indexOf(idp) > -1){

          right += widenDualPedigreeBranchesBy;

          if([...parentsIdps].indexOf(idp) > -1){

            let stemObj = {
              node,
              idp,
              segment: 'stem',
              stemStart: right - 10,
              stemEnd: right + 8 - 10,
              sideYPoint: top + 14,
            }

            branches.push(stemObj);
          }

          if([...gpIdps].indexOf(idp) > -1){

            let stemObj = {
              node,
              idp,
              segment: 'stem',
              stemStart: right - 6,
              stemEnd: right + 8 - 6,
              sideYPoint: top + 14,
            }

            branches.push(stemObj);
          }

        }

    } else if( isDualPedigree && typeof(side) !== 'undefined' && side === 'left') {

/*

      TWIG LEFT DUALPEDIGREE ******************************************************

 */
        if([...parentsIdps, ...gpIdps, ...ggpIdps].indexOf(idp) > -1){

          let customBranchObj = {}

          if( [...parentsIdps].indexOf(idp) > -1){
            left -= 5;
              customBranchObj = {
                sideYPoint: top + 14,
                // testColor: 'blue',
              }
          }

          if( [...gpIdps].indexOf(idp) > -1){
            left += (20 - widenDualPedigreeBranchesBy);
              customBranchObj = {
                sideYPoint: top + 15,
                // testColor: 'blue',
              }
          }

          if( [...ggpIdps].indexOf(idp) > -1){
            left += (30 - widenDualPedigreeBranchesBy);
            if( [14, 10].indexOf(idp) > -1){
              customBranchObj = {
                sideYPoint: top + 22,
                // testColor: 'blue',
              }
            }
            if( [9, 13].indexOf(idp) > -1){
              customBranchObj = {
                sideYPoint: top + 38,
                // testColor: 'orange',
              }
            }
            if( [8, 12].indexOf(idp) > -1){
              customBranchObj = {
                sideYPoint: top + 50,
                // testColor: 'green',
              }
            }
          }

          branches.push({
            node,
            idp,
            segment: 'twig',
            twigStart: left - 7.2 - 2,
            twigEnd: left,
            sideYPoint: top + 10.5,
            ...customBranchObj
          })
        }

/*

      STEM LEFT DUALPEDIGREE ******************************************************

 */

        if(stemIdps.indexOf(idp) > -1){

          right -= widenDualPedigreeBranchesBy;

          let stemObj = {
            node,
            idp,
            segment: 'stem',
            stemStart: right,
            stemEnd: right + 8,
            sideYPoint: top + 14,
          }

          if([...parentsIdps].indexOf(idp) > -1){

            stemObj = {...stemObj,
              stemStart: right + 20,
              stemEnd: right + 8 + 20,
            }

          }

          if([...gpIdps].indexOf(idp) > -1){

            stemObj = {...stemObj,
              stemStart: right + 29,
              stemEnd: right + 8 + 29,
            }

          }

          branches.push(stemObj)

        }

    }

    if( isDualPedigree && typeof(side) !== 'undefined' && side === 'right') right -= nodeWidth + 3.5 /* width of tab */;

    if( !isDualPedigree ){
      if([1, ...stemIdps].indexOf(idp) > -1){
        branches.push({
          node,
          idp,
          segment: 'tab',
          left: right - .75,
          top: top + 6,
          addboxLeft: right + 1,
          addboxTop: top + 5.5,
        })
      }

      if([1, ...stemIdps].indexOf(idp) > -1){
        branches.push({
          node,
          idp,
          segment: 'tabStr',
          left: right + 1,
          top: top + 8.5,
          addboxLeft: right + 1,
          addboxTop: top + 5.5,
        })
      }

      if([...gggpIdps].indexOf(idp) > -1){
        branches.push({
          node,
          idp,
          segment: 'tab',
          left: right - .75,
          top: top + 3,
          addboxLeft: right + 1,
          addboxTop: top + 5.5,
        })
      }

      if([...gggpIdps].indexOf(idp) > -1){
        branches.push({
          node,
          idp,
          segment: 'tabStr',
          left: right + 1,
          top: top + 5.5,
          addboxLeft: right + 1,
          addboxTop: top + 5.5,
        })
      }

      if([1, ...stemIdps].indexOf(idp) > -1){
        branches.push({
          node,
          idp,
          segment: 'tabTransparentHotSpot',
          left: right,
          top: top + 6,
        })
      }

      if([...gggpIdps].indexOf(idp) > -1){
        branches.push({
          node,
          idp,
          segment: 'tabTransparentHotSpot',
          left: right,
          top: top + 3,
        })
      }
    }

    const shiftContinue = -5;
    if(gggpIdps.indexOf(idp) > -1){
      branches.push({
        node,
        idp,
        segment: 'continueRect',
        left: left + 83 + shiftContinue,
        top: top + 3.5,
      })
    }

    if(gggpIdps.indexOf(idp) > -1){
      branches.push({
        node,
        idp,
        segment: 'continue',
        left: left + 93 + shiftContinue,
        top: top + 5.2,
      })
    }

    if(gggpIdps.indexOf(idp) > -1){
      branches.push({
        node,
        idp,
        segment: 'continueStr',
        left: left + 84 + shiftContinue,
        top: top + 5,
        // g: (maleIdps.includes(idp) ? 'm': 'f')
      })
    }

  });

  // const idpParent = getParentStemIdpFromChildTwigIdp({idp: 3, branchObj: pedigreeLayoutTree, idpParentsArr: [], prevKey:1}).idpParentsArr[0];
  // console.log(`idpParent: `, JSON.stringify(idpParent, null, 2));

  // if( isDualPedigree ){

  //   const childrenOfFocusUnionArray = getChildrenOfDualPedigreeFocusUnion({unions})

  //   childrenOfFocusUnionArray.forEach((childNode)=>{
  //     nodeObjs[childNode] = {

  //     };
  //   });

  // }


  return {nodeObjs, branches, titleName};

};

export const shiftForUnionRoot = ({side, left}) => {

if( side === 'left'){

    left += 8;

  }

  if( side === 'right'){

    left -= 8;

  }

  return left;

}


export const widenGreatGrandParentsForDualPedigree = ({idp, top}) => {

  // const ggpPaternalIdps = [ 12, 13, 14, 15]; // paternal greatgrandparents
  // const ggpMaternalIdps = [ 8, 9, 10, 11,]; // paternal greatgrandparents

  if(idp === 15 || idp === 11 ){
    top -= 20;
  }

  if(idp === 14 || idp === 10 ){
    top -= 8;
  }

  if(idp === 13 || idp === 9 ){
    top += 8;
  }

  if(idp === 12 || idp === 8 ){
    top += 20;
  }

  return top;

}

export const selectSVGFrame = ({imgProfileSVGPattern, dataURL, frame, testColor}) => {

  let frames = {
    'fancy': `<svg width="500" height="500" viewBox='0 0 500 500' xmlns='http://www.w3.org/2000/svg'><g transform="scale(1.05)">${imgProfileSVGPattern}<path d='M 115.682 115.524 L 183.446 115.524 C 203.493 105.586 226.079 100 249.972 100 C 273.865 100 296.454 105.586 316.504 115.524 L 385.995 115.524 L 385.995 186.655 C 394.976 205.899 399.994 227.364 399.998 250 C 400.002 272.655 394.984 294.137 385.995 313.394 L 385.995 386.174 L 313.011 386.174 C 293.861 395.048 272.522 400 250.026 400 C 227.53 400 206.19 395.048 187.036 386.174 L 115.682 386.174 L 115.682 316.824 C 105.649 296.702 100.004 274.01 100 250 C 99.996 225.972 105.642 203.263 115.682 183.129 Z M 248.829 113.058 C 228.183 113.058 208.602 117.623 191.037 125.801 L 126.875 125.801 L 126.875 187.386 C 117.097 206.292 111.574 227.761 111.574 250.522 C 111.574 273.283 117.097 294.752 126.875 313.658 L 126.875 375.17 L 190.879 375.17 C 208.484 383.394 228.121 387.987 248.829 387.987 C 269.537 387.987 289.174 383.394 306.779 375.17 L 373.106 375.17 L 373.106 308.947 C 381.431 291.216 386.084 271.413 386.084 250.522 C 386.084 229.631 381.431 209.829 373.106 192.097 L 373.106 125.801 L 306.621 125.801 C 289.056 117.623 269.475 113.058 248.829 113.058 Z' style='fill: ${testColor};'/>
        <path d='M 131.57 131.201 L 190.971 131.201 C 208.543 122.389 228.341 117.435 249.286 117.435 C 270.23 117.435 290.031 122.389 307.606 131.201 L 368.521 131.201 L 368.521 194.282 C 376.394 211.348 380.792 230.381 380.796 250.456 C 380.8 270.547 376.401 289.597 368.521 306.674 L 368.521 371.215 L 304.544 371.215 C 287.758 379.085 269.053 383.476 249.333 383.476 C 229.614 383.476 210.908 379.085 194.119 371.215 L 131.57 371.215 L 131.57 309.716 C 122.775 291.871 117.827 271.748 117.824 250.456 C 117.82 229.148 122.77 209.01 131.57 191.154 Z M 248.284 129.015 C 230.187 129.015 213.023 133.064 197.625 140.316 L 141.381 140.316 L 141.381 194.929 C 132.81 211.696 127.969 230.734 127.969 250.919 C 127.969 271.103 132.81 290.142 141.381 306.907 L 141.381 361.457 L 197.486 361.457 C 212.919 368.751 230.132 372.824 248.284 372.824 C 266.436 372.824 283.65 368.751 299.083 361.457 L 357.223 361.457 L 357.223 302.73 C 364.52 287.006 368.6 269.445 368.6 250.919 C 368.6 232.392 364.52 214.832 357.223 199.107 L 357.223 140.316 L 298.944 140.316 C 283.547 133.064 266.382 129.015 248.284 129.015 Z' style='fill: ${testColor};'/>
        <path  href='${dataURL}' fill='url(#image)' d='M 372.405 250.071 C 372.405 272.729 366.469 293.982 356.086 312.319 L 356.086 361.18 L 305.911 361.18 C 288.843 370.203 269.436 375.305 248.854 375.305 C 228.271 375.305 208.864 370.203 191.796 361.18 L 139.99 361.18 L 139.99 309.346 C 130.619 291.699 125.302 271.515 125.302 250.071 C 125.302 228.627 130.619 208.442 139.99 190.796 L 139.99 142.168 L 186.104 142.168 C 204.495 131.155 225.946 124.836 248.854 124.836 C 271.761 124.836 293.213 131.155 311.604 142.168 L 356.086 142.168 L 356.086 187.823 C 366.469 206.159 372.405 227.413 372.405 250.071 Z'/></g>
      </svg>`,
    'ellipse': `<svg width="500" height="500" viewBox='0 0 500 500' xmlns='http://www.w3.org/2000/svg'>${imgProfileSVGPattern}<ellipse style="fill: rgb(6, 6, 6);" cx="249.883" cy="251.523" rx="147.707" ry="164.23"/>
        <ellipse   href='${dataURL}' fill='url(#image)'  cx="250.811" cy="251.826" rx="134.844" ry="149.927"/>
      </svg>`,
    'circle': `<svg width="500" height="500" viewBox='0 0 500 500' xmlns='http://www.w3.org/2000/svg'>${imgProfileSVGPattern}<circle href='${dataURL}' fill='url(#image)' cx="250.391" cy="250.361" r="150.128"/>
        <path d="M 414.557 249.565 C 414.557 340.701 340.676 414.582 249.54 414.582 C 158.404 414.582 84.523 340.701 84.523 249.565 C 84.523 158.429 158.404 84.548 249.54 84.548 C 340.676 84.548 414.557 158.429 414.557 249.565 Z M 249.999 99.96 C 167.086 99.96 99.871 167.175 99.871 250.088 C 99.871 333.001 167.086 400.216 249.999 400.216 C 332.912 400.216 400.127 333.001 400.127 250.088 C 400.127 167.175 332.912 99.96 249.999 99.96 Z" style="fill: rgb(8, 8, 8);"/>
      </svg>`,
    'square': `<svg width="500" height="500" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">${imgProfileSVGPattern}<rect stroke="null" id="svg_4" height="327.99998" width="327.99998" y="86" x="86" fill=" rgb(8, 8, 8)"/>
      <rect  href='${dataURL}' fill='url(#image)' stroke="null" id="svg_5" height="294" width="294" y="102.99999" x="102.99998"/>
          </svg>`,
    'cross': `<svg width="500" height="500" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" xmlns:bx="https://boxy-svg.com">${imgProfileSVGPattern}
  <path stroke="#7AD6CA" id="svg_1" fill=" rgb(4, 4, 4)"  d="m380.35683,415.40608l-263.16153,-2.22432l0.27804,-32.89482l-32.89582,-0.27805l2.22432,-263.16153l32.89582,0.27805l0.27805,-32.89582l263.16153,2.22432l-0.27805,32.89582l32.89482,0.27804l-2.22432,263.16153l-32.89482,-0.27804l-0.27804,32.89482z"/>
  <path stroke="null" id="svg_2" fill=" rgb(216, 216, 216)"  d="m364.78862,396.7418l-230.11989,-1.97191l0.24313,-29.1623l-28.76499,-0.24649l1.94504,-233.29843l28.76499,0.24649l0.24313,-29.1623l230.11989,1.97191l-0.24313,29.1623l28.76499,0.24649l-1.94504,233.29843l-28.76499,-0.24649l-0.24313,29.1623z"/>
  <path  href='${dataURL}' fill='url(#image)' transform="translate(0 0)"  stroke="null" id="svg_2" d="m364.78862,396.7418l-230.11989,-1.97191l0.24313,-29.1623l-28.76499,-0.24649l1.94504,-233.29843l28.76499,0.24649l0.24313,-29.1623l230.11989,1.97191l-0.24313,29.1623l28.76499,0.24649l-1.94504,233.29843l-28.76499,-0.24649l-0.24313,29.1623z"/>
    </svg>`,
  };

  return frames[frame];

}

export const getSVGInnerPattern = ({frame, imgType, dataURL, width, height, shiftX, shiftY, node, fromWhere}) => {

  if( typeof(shiftX) === 'undefined' ) shiftX = 0;
  if( typeof(shiftY) === 'undefined' ) shiftY = 0;

  width =  typeof(width) === 'undefined' ? dimDualPedigreeSVGFrames[frame][imgType].innerFrameSideLength : width;
  height =  typeof(height) === 'undefined' ? dimDualPedigreeSVGFrames[frame][imgType].innerFrameSideLength: height;
  const xPos = dimDualPedigreeSVGFrames[frame][imgType].innerFrameSideRight + shiftX;
  const yPos = dimDualPedigreeSVGFrames[frame][imgType].innerFrameSideDown + shiftY;

  return `<defs>
        <pattern id='image' height='${1}' width='${1}'>
          <image x='${xPos}' y='${yPos}' height='${height}' width='${width}' href='${dataURL}'></image>
        </pattern>
      </defs>`;
}

export const getImgURLdataFromSVG = (dataURL) => {
  let blob = new Blob([dataURL], {type: 'image/svg+xml'});
  return URL.createObjectURL(blob); // https://dev.to/benjaminblack/using-a-string-of-svg-as-an-image-source-8mo
}
/*
export const changeFillColor = (svgString, customColor)=>{
  var modifiedSvgString = svgString.replace(/fill="#[0-9a-fA-F]{6}"/g, 'fill="' + customColor + '"');
  return modifiedSvgString;
}
*/
export const hasValue = (obj, value) => {
  return Object.keys(obj).some((key) => obj[key] === value);
}

export const divideChildrenAmongTheirParents = ({unions, children, partners}) => {

  let bastardArrayOfOjects = [];

  const childrenNodeIds = children.map((child)=>{
    return child.n;
  })

  const partnersNodeIds = partners.map((partner)=>{
    return partner.n;
  })

  let partnersObj = {}

  let matchedChildren = [];

  // console.log(`unions: `, JSON.stringify(unions, null, 2));

  let ghostNodeId = 0;
  let curMarriageId = 0;

  unions.forEach((unionObj)=>{

    // console.log(`unionObj: `, JSON.stringify(unionObj, null, 2));

    unionObj.c && unionObj.c.forEach((childNodeId)=>{
      if(childrenNodeIds.includes(childNodeId)){

        unionObj.p.forEach((p)=>{

          if(partnersNodeIds.includes(p)){
            if(typeof(partnersObj[p]) === 'undefined') {
              partnersObj[p] = {
                childrenNodesIds: undefined, // array of children
                unionId: undefined // union id to pass to addnode form
              }
            }
            if(typeof(partnersObj[p].childrenNodesIds) === 'undefined') {
              partnersObj[p].childrenNodesIds = [childNodeId];
            } else{
              partnersObj[p].childrenNodesIds.push(childNodeId);
            };
            partnersObj[p].marriageId = unionObj.m;
            matchedChildren.push(childNodeId);
          }

        }) // end unionObj.p.forEach

        const isDifferentMarriageRelationship = () => {
          return curMarriageId !== unionObj.m
        }

        if(unionObj.p.length === 1 && isDifferentMarriageRelationship()){ // Single parent
          ghostNodeId--;
          bastardArrayOfOjects.push({
            n: ghostNodeId,
            marriageId: unionObj.m,
            childrenNodesIds: unionObj.c
          })
          curMarriageId = unionObj.m;
        }

      }

    })

  })


  if(bastardArrayOfOjects.length > 0){

    bastardArrayOfOjects.forEach((bastardObj)=>{

      partnersObj[bastardObj.n] = {
        n: bastardObj.n,
        childrenNodesIds: bastardObj.childrenNodesIds,
      }

    });

  }

  // console.log(`bastardArrayOfOjects: `, JSON.stringify(bastardArrayOfOjects, null, 2));
  // console.log(`********** partnersObj: `, JSON.stringify(partnersObj, null, 2));
  return {
    partnersObj,
    bastardArrayOfOjects,
  }

}

export const buildImmediateFamily = ({focusPrId, lookUpPrId, lookUpNodeId, unions, sortByGender}) => {

  // console.log(`unions: `, JSON.stringify(unions, null, 2));

  let ghostNtCount = 0;
  const getGhostNode = ({gender, marriageId}) => {
    ghostNtCount--;
    return {
      nt: 'ghost',
      n: ghostNtCount,
      prId: ghostNtCount,
      fn: '',
      ln: '',
      nm: 'Unknown',
      dateAlive: '',
      marriageId,
      g: gender,
      img: {
        type: 'placeholder',
        src: `${imageBasePath}no_photo_${gender}.gif`
      }
    }
  }

    const getOtherPartner = ({n, p}) => {
      if(p[0] === n) return p[1];
      if(p[1] === n) return p[0];
    }

    const isFocusPrIdInPartnerGroup = ({focusPrId, p}) => {
      return p.includes(lookUpNodeId[focusPrId]);
    }

    const isFocusPrIdInChildrenGroup = ({focusPrId, c}) => {
      return c.includes(lookUpNodeId[focusPrId]);
    }

    let partners = [];
    let parents = [];
    let parentPair = undefined;
    let parentPairs = undefined;
    let allPotentialParentPairs = [];
    let siblings = [];
    let _siblings = undefined;
    let children = [];
    let _children = undefined;

    unions.forEach((obj) => {

      const { p, c, u, m } = obj;

      if(
        typeof(p) !== 'undefined' &&
        isFocusPrIdInPartnerGroup({focusPrId, p}) &&
        p.length === 2
      ){
        const otherPartnerAsNodeId = getOtherPartner({n:lookUpNodeId[focusPrId], p});
        if(otherPartnerAsNodeId) {
          lookUpPrId[otherPartnerAsNodeId].marriageId = m;
          partners.push(lookUpPrId[otherPartnerAsNodeId]);
        };
      }

      if(
          typeof(p) !== 'undefined'  &&
          typeof(c) !== 'undefined'  &&
          isFocusPrIdInPartnerGroup({focusPrId, p})
      ) {
        _children = c.map( (n)=>{
          return lookUpPrId[n];
        })
        children.push(..._children);
      }

      if(
          typeof(c) !== 'undefined'  &&
          isFocusPrIdInChildrenGroup({focusPrId, c})
      ) {
        if(typeof(p) !== 'undefined'){
          const _parents = p.map( (n)=>{
            lookUpPrId[n].marriageId = m;
            lookUpPrId[n].unionId = u;
            return lookUpPrId[n];
          })
          parents.push(_parents[0]);
          if(typeof(_parents[1]) !== 'undefined') parents.push(_parents[1]);
          if(_parents.length === 2){
            parentPair = [_parents[0].n, _parents[1].n];
            allPotentialParentPairs.push([_parents[0], _parents[1]])
          } else {
            allPotentialParentPairs.push((_parents[0].g === 'm' ? [_parents[0], getGhostNode({gender: 'f', marriageId: m})]: [getGhostNode({gender: 'm', marriageId: m}), _parents[0]]))
          }
        } else{
          allPotentialParentPairs.push([getGhostNode({gender: 'm', marriageId: m}), getGhostNode({gender: 'f', marriageId: m})])
        }
        _siblings = c.map( (n)=>{
          return lookUpPrId[n];
        })
        siblings.push(..._siblings);
      }

      if(typeof(parentPair) !== 'undefined'){
        if(typeof(parentPairs) === 'undefined') parentPairs = [];
        parentPairs.push(parentPair);
        parentPair = undefined;
      }

    });


    parents = uniqBy(parents, 'prId');
    partners = uniqBy(partners, 'prId');
    children = uniqBy(children, 'prId');
    siblings = uniqBy(siblings, 'prId');

    if(typeof(sortByGender) !== 'undefined' && sortByGender){
      parents = sortBy(parents, obj=>obj.g + obj.fn + obj.dob_y);
      partners = sortBy(partners, obj=>obj.g + obj.fn + obj.dob_y);
      children = sortBy(children, obj=>obj.g + obj.fn + obj.dob_y);
      siblings = sortBy(siblings, obj=>obj.g + obj.fn + obj.dob_y);
    }

    return {
      parents,
      parentPairs,
      siblings,
      partners,
      children,
      allPotentialParentPairs,
    }

}

export const buildImmediateFamilyObj = ({nodes, unions, lookUpPrId, lookUpNodeId, focusPrId, focusGender}) => {

  let partnerOrder = [];
  nodes.forEach((obj) => {

    const { n, pr_id, t, nm, g, fn, ln, nvp, a, e, dob_c, dod_c, dob_y, dod_y, l, p_o } = obj;

    if(typeof(p_o) !== 'undefined' && pr_id === focusPrId){
      partnerOrder = p_o.split(',')
    };

    lookUpNodeId[pr_id] = n;

    const dateAlive = buildDateAliveText({dob_c, dod_c, dob_y, dod_y, l})

    var _t;
    let imgObj = null;
    if(typeof(t) === 'undefined') {
      _t = `${imageBasePath}no_photo_${g}.gif`;
      imgObj = { type: 'placeholder', src: _t}
    } else{
      _t = t;
      imgObj = {
        type: 'real',
        src: _t,
        imageReset: false,
        height: 48, // always going to be 48 because fetch immediate family is pulling *t2.jpg
        width: 48,
      }
    }

    lookUpPrId[n] = {
      prId: pr_id,
      pr_id,
      n,
      nm/*: '123456789 123456789 123456789'*/,
      t,
      g,
      img: imgObj,
      fn,
      ln,
      nvp,
      a,
      e,
      dateAlive,
    };

  })

  let { parents, parentPairs, allPotentialParentPairs, siblings, children, partners } = buildImmediateFamily({focusPrId, lookUpPrId, lookUpNodeId, unions});

  const { partnersObj, bastardArrayOfOjects } = divideChildrenAmongTheirParents({unions, children, partners});

  if(bastardArrayOfOjects.length > 0){

    bastardArrayOfOjects.forEach((bastardObj)=>{

      const nm = ( !isDevelopment ? window.trl('Unknown', 'unknown name'): 'Unknown')

      let ghostGender = ( typeof(focusGender) !== 'undefined' && focusGender === 'm' ? 'f' : 'm');
      ghostGender = ( typeof(focusGender) !== 'undefined' && focusGender === 'u' ? 'u' : ghostGender);

      partners.push({
        nm: `(${nm})`,
        n: bastardObj.n,
        nt: 'ghost',
        g: ghostGender,
        img: { type: 'placeholder', src: `${imageBasePath}no_photo_u.gif`},
        marriageId: bastardObj.marriageId,
      })
      if( !partnerOrder.includes(bastardObj.n)){
        partnerOrder.push(bastardObj.n)
      }

    })

  }

  const immediateFamObj = {
    parents,
    parentPairs,
    allPotentialParentPairs,
    siblings,
    children,
    partners,
    partnersObj,
    partnerOrder,
  };

  // console.log(`immediateFamObj: `, JSON.stringify(immediateFamObj, null, 2));
  return immediateFamObj;

}

export const buildNodeObj = ({ _nodeObj, realXCoord, realYCoord, isPedigree}) => {

  // if(typeof(node.cids) !== 'undefined'){
  //   console.log('*********************');
  //   console.log('node:', JSON.stringify(node, null, 2));
  // }
  // if(typeof(node.nt) !== 'undefined' && node.nt === 'cc'){
  //   console.log('XXXXXXXXXXXXXXXXXXXXXX');
  //   console.log('node:', JSON.stringify(node, null, 2));
  // }
  const halfwidth = nodeWidth/2;
  const halfheight = nodeHeight/2;
  const {/* n,*/
    n, // node id
    a, // adder ... if a = 1 use 'add this person' otherwise derive name from nm field
    e,
    app, // add profile photo
    nn, // node number .. another identifier for profile left over....
    p, // is this pruned  flagged as "+" or undefined if is not pruned.
    cids, // cycle ids ...
    // t, // thumbnail
    fn, // first name
    ln, // last name
    mn, // middle name
    mdn, // maiden name
    sfx, // suffix
    dob_c, // date of birth circa
    dod_c, // date of death circa
    dob_y, // date of birth year
    dod_y, // date of death year
    d_r, // direct relative
    pr_id, // profile id
    pid, // public id
    g, // gender
    focus, // focus
    c, // c === 1 then make border blue
    mp, // mp === 1 then border is purple
    rl, // relationship-locked
    sh, // (public profiles) sh === 1 then make border green.
    nt, // node type: cc = 'cycle clone' OR ph = 'placeholder' OR 'ghost' fOR add this person OR u is now depreciated
    vsum, // value summary
    tm,  // tree match
    rm, // record match
    sm, // smart match
    gc, // gedcom
    npu, // is number of parent unions (if more than 1) -- shows that green box centered over the node, clicking that green box pops dialog by calling openParentChooser(pr_id)
    rm_vscore,
    sm_vscore,
    x,
    y,
    g_e,
    dna,
    l,
    nvt, // no viewing of prune trees or count
    nvp, // no hyperlinking out
    ptc, // parent conflict
    prc, // oartner conflict
    m_p, // merge pending
    inc, // inconsistency
    ntm, // nearby tree matches
    tmn, // tree match notify
    rmn, // record match notify
  } =  _nodeObj;
  let { t, tb, tmed, tlrg } =  _nodeObj;
  let { nm } = _nodeObj;

  // if(typeof(cids) !== 'undefined' ){
  //   console.log(` nm: `, nm, `cids: `, JSON.stringify(cids, null, 2), ` node: `, n);
  // }

  if(typeof(cids) !== 'undefined'){
    var cidsArr = cids.split(",");
    cidsArr = cidsArr.map((stringValue) => parseInt(stringValue, 10));
    cidsArr.unshift(n);
    var cyclemaster = n;
    var cidsLength = cidsArr.length;
  }


  const _tm = (typeof(tm) !== 'undefined' ? tm : 0);
  const _rm = (typeof(rm) !== 'undefined' ? rm : 0);
  const _sm = (typeof(sm) !== 'undefined' ? sm : 0);

  let match_count = parseInt(_tm, 10) + parseInt(_rm, 10) + parseInt(_sm, 10);
  match_count = (match_count < 100 ? match_count.toString(): '99+');


  // const thumbsArrayTest = [
  //   'https://s3.amazonaws.com/photos.geni.com/00/00/03/e7/sub73tid/000003e7_medium.jpg',
  //   'https://s3.amazonaws.com/photos.geni.com/p13/fc/90/36/0e/5344483e3eb1c378/20150724_043714_medium.jpg',
  //   'https://s3.amazonaws.com/photos.geni.com/p13/a9/45/69/ec/53444838b78e4da8/edith_and_joseph_bindel_medium.jpg',
  //   'https://s3.amazonaws.com/photos.geni.com/p13/b4/13/0b/8a/53444839fea36485/hyacinth_jessup_medium.jpg',
  //   'https://s3.amazonaws.com/photos.geni.com/p13/25/b5/f2/f7/53444842697253cb/blackburn_medium.jpg',
  // ];

  // t = thumbsArrayTest[4];

  // nm = '12345 67890 1234567890';


  var _t;
  let imgObj = null;
  if(typeof(t) === 'undefined') {
    _t = `${imageBasePath}no_photo_${g}.gif`;
    imgObj = { type: 'placeholder', src: _t}
  } else{
    _t = t;
    imgObj = {
      type: 'real',
      src: _t,
      imageReset: false,
    }
  }

  let left = undefined;
  let top  = undefined;
  let right = undefined;
  let bottom = undefined;
  let xCenter = undefined;
  let sidePoint = undefined;

  top = -1 * ((y - realYCoord) * heightScale);
  left = (x + realXCoord) * widthScale;
  right = left + nodeWidth;
  bottom = top + nodeHeight;
  xCenter = left + halfwidth;
  sidePoint = top + halfheight;

  // console.log(`{x, y, widthScale}: `, JSON.stringify({x, y, widthScale}, null, 2));

  if( focus ){

    grandparentRow = top - oneGenerationVerticalDistance;
    focusRow = top;

    window.grandparentRow = grandparentRow;
    window.focusRow = focusRow;

  }

  const {fullNameLineArr, fullNameLineArrWidth} = buildNameLineArray({nm, n, isPedigree});

  if( typeof(tmn) !== 'undefined' )  {
    // console.log(`tmn is:`, tmn);
  }

  if( typeof(rmn) !== 'undefined' )  {
    // console.log(`rmn is:`, rmn);
  }

  return {
    n,
    a, // adder ... if a = 1 use 'add this person' otherwise derive name from nm field
    e,
    app,
    nvp, //dev
    ptc, // parent conflict
    prc, // oartner conflict
    m_p,  // merge pending
    inc,  // inconsistency
    // ntm:( focus ? 1: null ),  // nearby tree matches
    // ntm:1,
    ntm,
    tmn,
    rmn,
    nn,
    p,
    cids,
    cyclemaster,
    cidsArr,
    cidsLength,
    // nm: getDummyText(4),
    // nm: '12345 67890 12345',
    // nm: "【(湖南湘鄉)】曾麟書 (竹亭)",
    nm,
    // nm: 'Generalkommissarie Henrik von Falkenberg',
    // fullNameLineArr: ( typeof(nm) !== 'undefined' ? buildNameLineArray({nm: "【(湖南湘鄉)】曾麟書 (竹亭)", n}): []),
    fullNameLineArr: ( typeof(nm) !== 'undefined' ? fullNameLineArr: []),
    fullNameLineArrWidth: ( typeof(nm) !== 'undefined' ? fullNameLineArrWidth: []),
    // t: _t,
    tb,
    tmed,
    tlrg: ( typeof(tlrg) !== 'undefined' ? tlrg: undefined),
    img:imgObj,
    fn,
    ln,
    mn,
    mdn,
    sfx,
    dob_c,
    dod_c,
    dob_y,
    dod_y,
    d_r,
    pr_id,
    prId: pr_id,
    pid,
    g,
    focus,
    c,
    mp,
    rl, // relationship-locked
    sh,
    photoBorderColor: derivePhotoBorderColor({c, mp, sh}),
    // vsum: getDummyText(),
    vsum: vsum,
    tm,
    rm,
    sm,
    // gc: 1,
    gc,
    // npu: ( getRandom(0,10) < 3 ? getRandom(0,10): undefined),
    npu: npu,
    rm_vscore,
    sm_vscore,
    top,
    right,
    bottom,
    left,
    xCenter,
    nt,
    match_count,
    hasExs: undefined,
    unionColors: [unrelatedColor],
    sideYPoints : [sidePoint],
    sideYpointIdx: 0,
    // grandparentRow,
    g_e: g_e,
    dna: dna,
    l: l,
    dateAlive: buildDateAliveText({dob_c, dod_c, dob_y, dod_y, l}),
    // dateAlive: '123123123123123',
    nvt,
    fetchedTreeAt: Date.now(),
  };
};


export const truncateWord = ( {str, length, useWordBoundary, fromWhere} ) =>{
  if (typeof(str) !== 'undefined' && str.length <= length) { return str; }
  var subString = str.substr(0, length-1);
  return (useWordBoundary
     ? subString.substr(0, subString.lastIndexOf(' '))
     : subString) + "...";
};

export const getWidthKonvaText = ({str, fontSize, fontFamily, fontStyle, lineHeight}) => {

  const strTest = new Konva.Text({
        x: 0,
        y: 0,
        text: str,
        fontSize,
        fontFamily,
        fontStyle,
        lineHeight,
        align: 'left'
      });

  return strTest.width();
}
/*

not work:

Elizabeth II & Philip Schleswig-Holstein-Sonderburg-Glücksburg


 */
export const isAlphaStr = (str) => {
    var patt = /^[a-zA-Z\u00C6\u00D0\u018E\u018F\u0190\u0194\u0132\u014A\u0152\u1E9E\u00DE\u01F7\u021C\u00E6\u00F0\u01DD\u0259\u025B\u0263\u0133\u014B\u0153\u0138\u017F\u00DF\u00FE\u01BF\u021D\u0104\u0181\u00C7\u0110\u018A\u0118\u0126\u012E\u0198\u0141\u00D8\u01A0\u015E\u0218\u0162\u021A\u0166\u0172\u01AFY\u0328\u01B3\u0105\u0253\u00E7\u0111\u0257\u0119\u0127\u012F\u0199\u0142\u00F8\u01A1\u015F\u0219\u0163\u021B\u0167\u0173\u01B0y\u0328\u01B4\u00C1\u00C0\u00C2\u00C4\u01CD\u0102\u0100\u00C3\u00C5\u01FA\u0104\u00C6\u01FC\u01E2\u0181\u0106\u010A\u0108\u010C\u00C7\u010E\u1E0C\u0110\u018A\u00D0\u00C9\u00C8\u0116\u00CA\u00CB\u011A\u0114\u0112\u0118\u1EB8\u018E\u018F\u0190\u0120\u011C\u01E6\u011E\u0122\u0194\u00E1\u00E0\u00E2\u00E4\u01CE\u0103\u0101\u00E3\u00E5\u01FB\u0105\u00E6\u01FD\u01E3\u0253\u0107\u010B\u0109\u010D\u00E7\u010F\u1E0D\u0111\u0257\u00F0\u00E9\u00E8\u0117\u00EA\u00EB\u011B\u0115\u0113\u0119\u1EB9\u01DD\u0259\u025B\u0121\u011D\u01E7\u011F\u0123\u0263\u0124\u1E24\u0126I\u00CD\u00CC\u0130\u00CE\u00CF\u01CF\u012C\u012A\u0128\u012E\u1ECA\u0132\u0134\u0136\u0198\u0139\u013B\u0141\u013D\u013F\u02BCN\u0143N\u0308\u0147\u00D1\u0145\u014A\u00D3\u00D2\u00D4\u00D6\u01D1\u014E\u014C\u00D5\u0150\u1ECC\u00D8\u01FE\u01A0\u0152\u0125\u1E25\u0127\u0131\u00ED\u00ECi\u00EE\u00EF\u01D0\u012D\u012B\u0129\u012F\u1ECB\u0133\u0135\u0137\u0199\u0138\u013A\u013C\u0142\u013E\u0140\u0149\u0144n\u0308\u0148\u00F1\u0146\u014B\u00F3\u00F2\u00F4\u00F6\u01D2\u014F\u014D\u00F5\u0151\u1ECD\u00F8\u01FF\u01A1\u0153\u0154\u0158\u0156\u015A\u015C\u0160\u015E\u0218\u1E62\u1E9E\u0164\u0162\u1E6C\u0166\u00DE\u00DA\u00D9\u00DB\u00DC\u01D3\u016C\u016A\u0168\u0170\u016E\u0172\u1EE4\u01AF\u1E82\u1E80\u0174\u1E84\u01F7\u00DD\u1EF2\u0176\u0178\u0232\u1EF8\u01B3\u0179\u017B\u017D\u1E92\u0155\u0159\u0157\u017F\u015B\u015D\u0161\u015F\u0219\u1E63\u00DF\u0165\u0163\u1E6D\u0167\u00FE\u00FA\u00F9\u00FB\u00FC\u01D4\u016D\u016B\u0169\u0171\u016F\u0173\u1EE5\u01B0\u1E83\u1E81\u0175\u1E85\u01BF\u00FD\u1EF3\u0177\u00FF\u0233\u1EF9\u01B4\u017A\u017C\u017E\u1E93]+$/;
    return patt.test(str);
}

export const isAsianStr = (str) => {
  return str.match(/[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f]/)
}

export const encodeIfNeeded = (str) => {

        // console.log(`%c str: ${str}`, [
        // 'color: white',
        // 'background: blue',
        // 'font-size: 14px',
        // 'border: 5px solid red',
        // 'padding: 10px',
        // ].join(';'));

  if(!isAlphaStr(str)){

        // console.log(`%c needed?  Yes`, [
        // 'color: white',
        // 'background: green',
        // 'font-size: 14px',
        // 'border: 5px solid red',
        // 'padding: 10px',
        // ].join(';'));

        // console.log(`%c${encodeURI(str)}`, [
        // 'color: white',
        // 'background: orange',
        // 'font-size: 14px',
        // 'border: 5px solid red',
        // 'padding: 10px',
        // ].join(';'));

    return encodeURI(str);

  }

        // console.log(`%c needed?  No`, [
        // 'color: white',
        // 'background: red',
        // 'font-size: 14px',
        // 'border: 5px solid red',
        // 'padding: 10px',
        // ].join(';'));


  return str;
}

export const buildSetPageProfilesObj = ({nodeObj}) => {

  const firstName = nodeObj.fn;
  const id = nodeObj.pr_id;
  const mugshotID = null;
  const mugshotURL = nodeObj.tb;
  const name = nodeObj.nm;
  const node_number = nodeObj.n;

  return {
        firstName,
        id,
        mugshotID,  // or null
        mugshotURL,  // tb param
        name,
        node_number
      };
}

export const getNodesWithManyUnions = (unions) => {  // sagas.js
  let nodesFromUnions = [];
  unions.forEach((union) => {
    const { p } = union;
    if(typeof(p) !== 'undefined'){
      if(p.length > 1) nodesFromUnions.push(p[0]);
      if(typeof(p[1]) !== 'undefined') nodesFromUnions.push(p[1]);
    }
  });

  let nodeUnionCount = {};
  nodesFromUnions.forEach((nodeId) => {
    const totalNodes = ( nodeUnionCount[nodeId] || 0 ) + 1;
    nodeUnionCount[nodeId] = totalNodes;
  });
  let nodesWithManyUnions = {};
  for( let key in nodeUnionCount ) {
    if(nodeUnionCount[key] > 1) nodesWithManyUnions[key] = nodeUnionCount[key];
  }
  return nodesWithManyUnions;
};

export const doesNodeHaveManyUnions = ({node2check, nodesWithManyUnions, union}) => {

  let boolResponse = false;

  for( let node in nodesWithManyUnions){
    if(node2check === parseInt(node, 10) ) boolResponse = true;
  }

  return boolResponse;
}

export const extractGhostNodes = (nodes) => {  // sagas.js
  const _ghostNodes = nodes.map((nodeObj) => {
    if(nodeObj.nt === 'ghost') return nodeObj.n;
    else return null;
  })
  const ghostNodes = compact(_ghostNodes);
  return ghostNodes;
};

export const getAddNodeObjFromUnions = ({ghostsNode, unions, addNodeObjsCopy}) => {
    let marriageId = null;
    let onlyChildOfGhostParents = null;
    let useAltLabel = null;
    const _spouseNodes = unions
    .map(  obj => {
      const pair = obj.p;
      if(typeof(pair) === 'undefined') return null;
      var _spouse = undefined;
      if( pair[0] === ghostsNode ) { _spouse = pair[1];}
      if( pair[1] === ghostsNode ) { _spouse = pair[0];}
      if( pair[0] === ghostsNode || pair[1] === ghostsNode) {
        if(addNodeObjsCopy[pair[0]].nt  === 'ghost' && addNodeObjsCopy[pair[1]].nt === 'ghost'){
          useAltLabel = true;
        } else{
          useAltLabel = false;
        }
        marriageId = obj.m;
        if(parseInt(marriageId, 10) === -1) {
          onlyChildOfGhostParents = obj.c[0];
          useAltLabel = true;
        }
        return _spouse;
      }
      return null;
    })

    const spouseNodes = compact(_spouseNodes);

    const spouseNode = spouseNodes[0];

    let backendGhostLabel = null;
    let pr_id = null;
    const { n, g,  } = addNodeObjsCopy[spouseNode];

    addNodeObjsCopy[spouseNode].marriageId = marriageId;
    if(parseInt(marriageId, 10) === -1 ) {
      pr_id = addNodeObjsCopy[onlyChildOfGhostParents].pr_id;
      backendGhostLabel = howThisParentWouldBeCalled(g);
    } else {
      pr_id = addNodeObjsCopy[spouseNode].pr_id;
      backendGhostLabel = howThisSpouseWouldBeCalled(g);
    }

    let frontendGhostLabel = null;
    if(useAltLabel){
      frontendGhostLabel = howThisParentWouldBeCalled(g);
    } else {
      frontendGhostLabel = howThisParentWouldBeCalled(g);
      // frontendGhostLabel = howThisSpouseWouldBeCalled(g);
    }

    let choice = null;
    if(parseInt(marriageId, 10) === -1 ) {
      choice = howThisChoiceParentWouldBeCalled(g);
    } else {
      choice = howThisChoiceSpouseWouldBeCalled(g);
    }

    const nonAddableGhost = howThisNonAddableGhostWouldBeCalled(g);

    const spouseObj = {
      n,
      pr_id,
      prId: pr_id,
      g,
      marriageId,
      frontendGhostLabel,
      backendGhostLabel,
      nonAddableGhost,
      choice
    }

    return spouseObj;

    // console.log('B');
    // console.log('C');
    // console.log('D');
}

export const isNodeAncestor = (nodeObj) => { // assembletree.js
  const { top } = nodeObj;
  return ( top < grandparentRow ? true : false);
};

export const reviseNodesObjForNodesWithManyUnions = ({ nodesWithManyUnions, nodeObjs }) => {  // sagas.js
  let sideYpoint = null;
  for( let n in nodesWithManyUnions ){
    let countOfUnionsForNode = nodesWithManyUnions[ n ];
    let stockColorIdx = 0;
    const nodeObj = nodeObjs[ n ];
    if(typeof(nodeObj) === 'undefined') continue;
    let {top, bottom} = nodeObj;
    let heightOfNodeBox = (bottom - top);
    if(countOfUnionsForNode < 4){
      heightOfNodeBox = (bottom - top) / 2;
      top += (heightOfNodeBox) / 2;
    }
    nodeObj[ 'hasExs' ] = true;
    nodeObj[ 'sideYPoints' ] = [];
    nodeObj[ 'unionColors' ] = [];
    let sectionHeight = null;
    if(isNodeAncestor(nodeObj)) {
      nodeObj.isAncestor = true;
    }
    if( isNodeAncestor(nodeObj) &&
        typeof(nodeObj['d_r']) !== 'undefined') {
      sectionHeight = heightOfNodeBox / (countOfUnionsForNode + 2);
    } else{
      sectionHeight = heightOfNodeBox / (countOfUnionsForNode + 1);
    }
    sideYpoint = top + sectionHeight;
    while( countOfUnionsForNode > 0 ) {
      nodeObj[ 'sideYPoints' ].push( sideYpoint );
      nodeObj[ 'unionColors' ].push( exStockColors[ stockColorIdx ] );
      sideYpoint = sideYpoint + sectionHeight;
      countOfUnionsForNode--;
      stockColorIdx++;
    }
    // nodeObj[ 'sideYPoints' ].reverse();
    // nodeObj[ 'unionColors' ].reverse();
    nodeObjs[ n ] = nodeObj;
  }
  return nodeObjs;
};

export const designateNodesThatAreSeparated = ({ unions, nodeObjs }) => {
  unions.forEach((union)=>{
    let isPairCount = 0;
    if(union.t === 'x' && typeof(union.p) !== 'undefined' ){
      if(typeof(nodeObjs[union.p[0]]) !== 'undefined' && typeof(nodeObjs[union.p[0]].idp) !== 'undefined') {
        isPairCount++;
      }
      if(typeof(nodeObjs[union.p[1]]) !== 'undefined' && typeof(nodeObjs[union.p[1]].idp) !== 'undefined') {
        isPairCount++;
      }
    }
    if(isPairCount === 2){
        nodeObjs[union.p[0]].hasExs = true;
        nodeObjs[union.p[1]].hasExs = true;
    }
  })
  return nodeObjs;
};


export const waterDefaultZoomLevelDualPed = ({ nodeObjs }) => {

  const custom = {
    "zoomLevelValue": defaultZoomLevelValueForDualPedigree,
  };

  for(let node in nodeObjs) {

    if(parseInt(node, 10) > 0){
      if(nodeObjs[node].img.type !== 'placeholder'){
        if( typeof(nodeObjs[node].dualPedigreeCustom) === 'undefined' ){
          nodeObjs[node].dualPedigreeCustom = custom;
        }
      }
    }

  }

return nodeObjs;

};

export const adaptWidthFullnameArrrayForCustomFontsDualpedigree = ({ nodeObjs, fontFamily }) => {
// let width = undefined;
  // fontArray.forEach((obj)=>{
  //   if(obj.name === fontFamily) width = obj.width;
  // })
  const width = getPropFromObjInArray({arr: fontArray, searchkey: fontFamily, key: 'name', value: 'width'})

  for (let node in nodeObjs) {
    const nm = nodeObjs[node].nm;
    const { fullNameLineArr, fullNameLineArrWidth}  = buildNameLineArray({nm, n: node, width});
    nodeObjs[node].fullNameLineArr = fullNameLineArr;
    nodeObjs[node].fullNameLineArrWidth = fullNameLineArrWidth;
  }
  return nodeObjs;

};


export const getUnionLineCoordsForPartners = ({ union, nodeObjs }) => {
  const { p, t } = union;
  const isSeparated = ( t === 'x' ? true: false);
  const partnerWithExs = ( typeof(nodeObjs[p[0]]) !== 'undefined' && typeof(nodeObjs[p[0]]['hasExs']) !== 'undefined' ? 0 : 1);
  const partnerWithExNodeObj = nodeObjs[p[partnerWithExs]];
  const node1 = nodeObjs[p[0]];
  const node2 = nodeObjs[p[1]];

  if(typeof(node1) === 'undefined' || typeof(node2) === 'undefined'){
    console.trace('getUnionLineCoordsForPartners');
    return;
  }

  const start = ( node1['left'] < node2['left'] ? node1['right']: node2['right']);
  const end = ( node1['left'] > node2['left'] ? node1['left']: node2['left']);

  const sideYPoints = partnerWithExNodeObj['sideYPoints'];
  const unionColors = partnerWithExNodeObj['unionColors'];

  let sideYpointIdx = partnerWithExNodeObj['sideYpointIdx'];
  const sideYPoint = sideYPoints[sideYpointIdx];
  const unionColor = unionColors[sideYpointIdx];
  partnerWithExNodeObj['sideYpointIdx'] = sideYpointIdx + 1; //BOOK
  const exNode = partnerWithExNodeObj.n

  return {start, sideYPoint, end, isSeparated, unionColor, exNode };

};

// export const resetSideYPointIdx = ({nodeObjs}) =>{
//   for (let n in nodeObjs) {
//     nodeObjs[n]['sideYpointIdx'] = 0;
//   }
// }

export const resetSideYPointIdx = ({nodes, nodeObjs}) => {

  if( nodes.length > 0){
    for (let idx = 0; idx <= nodes.length; idx++) {
      var n = nodes[idx];
      if(typeof(nodeObjs[n]) !== 'undefined' ) {
        nodeObjs[n]['sideYpointIdx'] = 0;
      }
    }
  }

}

// export const reviseNodeObjWithPermissions = ({ nodeObj, permissions }) => { // assembletree.js
//   nodeObj.permissions = permissions;
//   return nodeObj;
// };

export const getRightMostNodeObj = ({nodeObj_1, nodeObj_2}) => {
  if(nodeObj_1['xCenter'] < nodeObj_2['xCenter']) return nodeObj_2;
  else return nodeObj_1;
}

export const getLeftMostNodeObj = ({nodeObj_1, nodeObj_2}) => {
  if(nodeObj_1['xCenter'] > nodeObj_2['xCenter']) return nodeObj_2;
  else return nodeObj_1;
}

export const leftSideHasLessPartners = ({leftNodeObj, rightNodeObj}) => {
  return ( leftNodeObj.sideYPoints.length < rightNodeObj.sideYPoints.length ? true : false);
}

// const xHandlePosBetweenForkCorners = ({forkCornerArray, xHandlePos}) => {
//   if( xHandlePos > forkCornerArray[0] &&  xHandlePos < forkCornerArray[1] ) return true;
//   else return false;
// }

export const getSideWithLeastMultiplePartners = ({leftNodeObj, rightNodeObj}) => {
  return ( leftNodeObj.sideYPoints.length < rightNodeObj.sideYPoints.length ? leftNodeObj : rightNodeObj);
}

export const getForkBaseRange = ({union, nodeObjs, xHandlePos, isGoalPost}) => {
  if(typeof(union.c) === 'undefined') return undefined;
  const children = union.c;
  const prongArray = children.map( (child) => {
    return nodeObjs[child].xCenter;
  });

  const startBaseX = prongArray[0];
  const endBaseX = prongArray[prongArray.length -1 ];

  const forkBaseRangeArray = [];

  if(isGoalPost) {

    forkBaseRangeArray[0] = startBaseX;
    forkBaseRangeArray[1] = endBaseX;

  } else {

    forkBaseRangeArray[0] = ( xHandlePos < startBaseX ? xHandlePos : startBaseX);
    forkBaseRangeArray[1] = ( xHandlePos > endBaseX ? xHandlePos : endBaseX);
  }

  return forkBaseRangeArray;
}

const getForkBaseLength = ({union, nodeObjs}) => {
  return (
      typeof(nodeObjs[union.p[1]]) !== 'undefined' &&
      typeof(nodeObjs[union.p[1]].xCenter) !== 'undefined'
        ?
      Math.abs(nodeObjs[union.p[1]].xCenter - nodeObjs[union.p[0]].xCenter)
        :
      0
    );
}

const bothPartnersRemarried = ({union, nodesWithManyUnions}) => {
  return  doesNodeHaveManyUnions({node2check: union['p'][0], nodesWithManyUnions, union}) &&
          doesNodeHaveManyUnions({node2check: union['p'][1], nodesWithManyUnions, union})
}

const atLeastOnePartnerRemarried = ({union, nodesWithManyUnions}) => {
  return  (!doesNodeHaveManyUnions({node2check: union['p'][0], nodesWithManyUnions, union}) &&
            doesNodeHaveManyUnions({node2check: union['p'][1], nodesWithManyUnions, union}))
                                  ||
          (doesNodeHaveManyUnions({node2check: union['p'][0], nodesWithManyUnions, union}) &&
            !doesNodeHaveManyUnions({node2check: union['p'][1], nodesWithManyUnions, union}))
}

const bothPartnersOnlyWithEachOther = ({union, nodesWithManyUnions}) => {
  return  !doesNodeHaveManyUnions({node2check: union['p'][0], nodesWithManyUnions, union}) &&
          !doesNodeHaveManyUnions({node2check: union['p'][1], nodesWithManyUnions, union})
}

const getxHandlePos = ({union, nodeObjs, isGoalPost, nodesWithManyUnions}) => {

  const nodeObj_1 = nodeObjs[union['p'][0]];
  const nodeObj_2 = nodeObjs[union['p'][1]];

  const leftNodeObj = getLeftMostNodeObj({nodeObj_1, nodeObj_2});
  const rightNodeObj = getRightMostNodeObj({nodeObj_1, nodeObj_2});

  const buffer = 0;

  const xLeftHandlePos = leftNodeObj['right'] + ( distanceBetweenNodes / 2 ) - buffer;
  const xRightHandlePos = rightNodeObj['left'] - ( distanceBetweenNodes / 2 ) + buffer ;

  if(isGoalPost){

    const children = union.c;
    const goalPostWidth = Math.abs(leftNodeObj['xCenter'] - rightNodeObj['xCenter']);

    if(children.length === 1 && onlyChildNodeIsBetweenParents( union, nodeObjs ) ) {

      return nodeObjs[children[0]].xCenter;

    }  else if (

      children.length === 1  && !onlyChildNodeIsBetweenParents( union, nodeObjs )

      ){

      return leftNodeObj['xCenter'] + ( goalPostWidth / 2 ) + (distanceBetweenNodes / 2);

    } else if (

      bothPartnersRemarried({union, nodesWithManyUnions})

      ){

      return leftNodeObj['xCenter'] + ( goalPostWidth / 2 ) + (distanceBetweenNodes / 2);

    } else if (

      bothPartnersOnlyWithEachOther({union, nodesWithManyUnions}) ||
      atLeastOnePartnerRemarried({union, nodesWithManyUnions})

      ){

      return leftNodeObj['xCenter']  + (goalPostWidth / 2);

    } else {

      const arrayOfXcenters = children.map( node => nodeObjs[node].xCenter);
      const average = arr => arr.reduce( ( p, c ) => p + c, 0 ) / arr.length;
      return average( arrayOfXcenters );

    }
  }

  /*
   * Giving custody of descendants to (the side) partner with the least previous multiple partners
   */

  return ( leftSideHasLessPartners({leftNodeObj, rightNodeObj}) ? xLeftHandlePos: xRightHandlePos);
};

export const augmentUnionArrayOfObjectsDerivedFromNodeObjs = ({unions, nodeObjs, nodesWithManyUnions}) => {

  return unions.map((union) => {

    if(typeof(union['p']) === 'undefined'){
      console.log('Mike should check this one: ');
      console.log(JSON.stringify(union, null, 2));
      return union;
    }

    if(typeof(nodeObjs[union['p'][0]]) === 'undefined' ||
       typeof(nodeObjs[union['p'][1]]) === 'undefined'
    ) return union;

    const nodeObj_1 = nodeObjs[union['p'][0]];
    const nodeObj_2 = nodeObjs[union['p'][1]];

    const isGoalPost = isUnionAboveGrandparentNodeRowNrelated(union, nodeObjs);

    const xHandlePos = getxHandlePos({union, nodeObjs, isGoalPost, nodesWithManyUnions});

    const length = getForkBaseLength({union, nodeObjs}); // Used for sorting longest lines to the top.

    const forkBaseYPos = nodeObj_1['bottom'] + ( handleHeight * 2 );

    if(isGoalPost){
      const leftNodeObj = getLeftMostNodeObj({nodeObj_1, nodeObj_2});
      const rightNodeObj = getRightMostNodeObj({nodeObj_1, nodeObj_2});
      var goalPostBaseRange = [leftNodeObj['xCenter'], rightNodeObj['xCenter']];
      var goalPostBaseYPos = nodeObj_1['bottom'] + goalPostHeight;
    }

    return {
      ...union,
      ...{
        length,
        isGoalPost,
        xHandlePos,
        goalPostBaseYPos,
        goalPostBaseRange,
        forkBaseYPos,
        forkBaseRange: getForkBaseRange({union, nodeObjs, xHandlePos,isGoalPost}),
    }};
  })
};


export const changeForkBaseYPosForUnionsOfMultiplePartners = ({unions, nodeObjs, nodesWithManyUnions}) => {

  const heightOfChannelBetweenGoalPostAndForkBase = handleHeight;
  const obj = {};
  for(let node in nodesWithManyUnions){

    node = parseInt(node, 10);
    obj[node] = {};
    obj[node].unionIds = [];
    obj[node].baseSegments = [];
    obj[node].totalNumSegments = 0;
    obj[node].heightBetweenSegments = 0;

    /*
     * First Pass to determine idp of segments
     * So we can get heightBetweenSegments
     */

    unions.forEach((union) => {
      if(typeof(union['p']) === 'undefined'){
        console.log('Mike should check this one: ');
        console.log(JSON.stringify(union, null, 2));
        return null;
      }
      if(typeof(nodeObjs[union['p'][0]]) === 'undefined' ||
         typeof(nodeObjs[union['p'][1]]) === 'undefined'
      ) return null;
      const nodeObj_1 = nodeObjs[union['p'][0]];
      const nodeObj_2 = nodeObjs[union['p'][1]];
      const leftNodeObj = getLeftMostNodeObj({nodeObj_1, nodeObj_2});
      const rightNodeObj = getRightMostNodeObj({nodeObj_1, nodeObj_2});
      if(leftNodeObj.n === node || rightNodeObj.n === node){
          if(union.isGoalPost) obj[node].totalNumSegments++;
          if(union.forkBaseRange) obj[node].totalNumSegments++;
      }
    });

    obj[node].heightBetweenSegments = heightOfChannelBetweenGoalPostAndForkBase / obj[node].totalNumSegments;

    let numSegments = 0;
    unions.forEach((union) => {
      if(typeof(union['p']) === 'undefined'){
        console.log('Mike should check this one: ');
        console.log(JSON.stringify(union, null, 2));
        return null;
      }
      if(typeof(nodeObjs[union['p'][0]]) === 'undefined' ||
         typeof(nodeObjs[union['p'][1]]) === 'undefined'
      ) return null;

      const nodeObj_1 = nodeObjs[union['p'][0]];
      const nodeObj_2 = nodeObjs[union['p'][1]];
      const leftNodeObj = getLeftMostNodeObj({nodeObj_1, nodeObj_2});
      const rightNodeObj = getRightMostNodeObj({nodeObj_1, nodeObj_2});

      if(leftNodeObj.n === node || rightNodeObj.n === node){

        obj[node].unionIds.push(union.u);

        const commonObj = {
          unionId: union.u,
          spouseNode: ( leftNodeObj.n === node ? rightNodeObj.n : leftNodeObj.n),
        }

        if(union.isGoalPost) {
          numSegments++;
          obj[node].baseSegments.push({
            ...commonObj,
            isGoalPost: true,
            range: union.goalPostBaseRange,
            goalPostBaseYPos: union.goalPostBaseYPos,
          });
        }

        if(union.forkBaseRange) {
          union.forkBaseYPos -= numSegments * obj[node].heightBetweenSegments;
          // union.forkBaseYPos -= numSegments * 1.5;
          numSegments++;
          obj[node].baseSegments.push({
            ...commonObj,
            range: union.forkBaseRange,
            forkBaseYPos: union.forkBaseYPos,
          });

        }

      }

      union.heightBetweenSegments = obj[node].heightBetweenSegments;

      return null;
    })
  }


  return obj;


/*

  return {
    13: {
      unionIds: [],
      baseSegments: [],
      orderBaseSegments: [{
          unionId: 0,
          yBasePos: 0,
        },{
          unionId: 1,
          yBasePos: 1,
        },
      ]
  }};

  */
}


export const unionHasDescedants = (union) => { // assembletree.js
  return union.hasOwnProperty('c');
}

export const unionIsPartnersOfTwoNodes = (union) => {
  return typeof(union) !== 'undefined' && union.hasOwnProperty('p') && union.p.length === 2;
}

export const eitherPartnerHasExs = (union, nodeObjs) => {
  return typeof(nodeObjs[union['p'][0]]['hasExs']) !== 'undefined' ||
         typeof(nodeObjs[union['p'][1]]['hasExs']) !== 'undefined';
};

export const bothPartnersDirectlyRelated = (union, nodeObjs) => {
  return typeof(nodeObjs[union['p'][0]]['d_r']) !== 'undefined' && typeof(nodeObjs[union['p'][1]]['d_r']) !== 'undefined'; };


export const eitherPartnerDirectlyRelated = (union, nodeObjs) => {
  return typeof(nodeObjs[union['p'][0]]['d_r']) !== 'undefined' || typeof(nodeObjs[union['p'][1]]['d_r']) !== 'undefined'; };

export const isUnionAboveGrandparentNodeRowNrelated = (union, nodeObjs) => {
  const { top } = nodeObjs[union['p'][0]];
  return ( top < grandparentRow && bothPartnersDirectlyRelated(union, nodeObjs) ? true : false);
};

export const isUnionBelowOrEqualFocusNodeRowNrelated = (union, nodeObjs) => {
  const { top } = nodeObjs[union['p'][0]];
  return ( top  >= focusRow && eitherPartnerDirectlyRelated(union, nodeObjs) ? true : false);
};

export const isUnionEqualGrandParentNodeRowNrelated = (union, nodeObjs) => {
  const { top } = nodeObjs[union['p'][0]];
  return ( top === grandparentRow && eitherPartnerDirectlyRelated(union, nodeObjs) ? true : false);
};

export const isUnionBelowOrEqualToFocusNodeLevelNrelated = (union, nodeObjs) => {
  const { top } = nodeObjs[union['p'][0]];
  return ( top  < focusRow  && eitherPartnerDirectlyRelated(union, nodeObjs) ? true : false);
};

export const onlyChildNodeIsBetweenParents = (union, nodeObjs) => {
  const onlyChildNode = union.c[0];
  const onlyChildNodeObj = nodeObjs[onlyChildNode];

  // let fatherNode = nodeObjs[union.p[0]].g === 'm' ? union.p[0] : union.p[1];
  // let motherNode = nodeObjs[union.p[0]].g === 'f' ? union.p[0] : union.p[1];

  let fatherNode = union.p[0];
  let motherNode = union.p[1];

  // if( (nodeObjs[union.p[0]].g === 'f' && nodeObjs[union.p[1]].g === 'f') ||  // lesbians
  //     (nodeObjs[union.p[0]].g === 'u' && nodeObjs[union.p[1]].g === 'f') ||  // first partner transgender
  //     (nodeObjs[union.p[0]].g === 'f' && nodeObjs[union.p[1]].g === 'u') ||  // second partner transgender
  //     (nodeObjs[union.p[0]].g === 'u' && nodeObjs[union.p[1]].g === 'u')     // both transgender
  // ){
  //   fatherNode = union.p[0];
  //   motherNode = union.p[1];
  // }

  const fatherNodeObj = nodeObjs[fatherNode];
  const motherNodeObj = nodeObjs[motherNode];

  if(onlyChildNodeObj.xCenter < fatherNodeObj.xCenter ||
     onlyChildNodeObj.xCenter > motherNodeObj.xCenter
  ) {
    return false;
  }
  return true;
};

export const isAtLeastOneChildRelated = (children, nodeObjs) => { // assembletree.js
  let result = false;
  children.forEach((child) => {
    if( typeof(nodeObjs[child]['d_r']) !== 'undefined') result = true;
  });
  return result;
};

export const getCenterXFromChildren = (children, nodeObjs) => { // assembletree.js
  const xCenters = children.map( (child) => nodeObjs[child].xCenter );
  let leftmostX = Math.min(...xCenters);
  let rightmostX = Math.max(...xCenters);
  return ((rightmostX - leftmostX) / 2) + leftmostX;
};

export const isNodeWithinViewport = ({ nodeObj, viewPortSides, viewPortBuffer }) => { // assembletree.js
  let response = false;
  if(
      nodeObj.right >= ( viewPortSides.left - viewPortBuffer) &&
      nodeObj.left <=  ( viewPortSides.right + viewPortBuffer)
  ) {
    response = true;
  }
  return response;
};

export const isUnionWithinViewport = ({ union, nodeObjs, viewPortSides }) => { // assembletree.js

  if(typeof(union.p) === 'undefined') return;

  let response = false;

  let childrenNodeObjsArray = [];
  const partnerNodeObjsArray = union.p.map((nodeId) => { return nodeObjs[nodeId];});
  if(union.hasOwnProperty('c')){
    childrenNodeObjsArray = union.c.map((nodeId) => { return nodeObjs[nodeId];});
  }

  const combinedNodeObjsArray = [...childrenNodeObjsArray, ...partnerNodeObjsArray];

  const lefts = combinedNodeObjsArray.map((nodeObj) => {
    if(typeof(nodeObj) !== 'undefined') return nodeObj.left;
    else return null;
  });

  const rights = combinedNodeObjsArray.map((nodeObj) => {
    if(typeof(nodeObj) !== 'undefined') return nodeObj.right;
    else return null;
  });

  let leftist = Math.min(...lefts);
  let rightist = Math.max(...rights);

  // console.log('>>>', 'leftist:', leftist);
  // console.log('>>>', 'rightist:', rightist);
  // console.log('>>>', '++++++++++');

  if(rightist >= ( viewPortSides.left - viewPortBuffer) &&
     leftist <=  ( viewPortSides.right + viewPortBuffer)
  ) {
    response = true;
  }

  return response;

};


export const makeArrayOfHalfValuesStartingWith = (value, arrayLength) => { // base.js

  const array =[];
  var halfValue = value;
  for(let i = 0; i < arrayLength; i++){
    halfValue /= 2;
    array.push(halfValue);
  }

  return array;

};

export const buildArrayOfScalesForZooming = (direction, steps, fromScale, toScale) => { // base.js
    const differenceBetweenScales = ( direction === 'out' ? fromScale - toScale : toScale - fromScale);
    const halfValueArray = makeArrayOfHalfValuesStartingWith( differenceBetweenScales, steps - 1);
    const zoomScalesArr = halfValueArray.map((value) => {
      if(direction === 'out'){
        fromScale -= value;
      } else {
        fromScale += value
      }
      return fromScale;
    });
    zoomScalesArr.push(toScale);
    return zoomScalesArr;
}

export const deriveFetchTreeRangeCoordinates = ({canvasWidth, canvasHeight}) => { // sagas.js

  const scaledCanvasWidth = canvasWidth / targetFocusDesktopScale;
  const scaledCanvasHeight = canvasHeight / targetFocusDesktopScale;


  const serverToClientRatio = parseInt(urlGet('serverToClientRatio'), 10) ||  10  // Retrieve more initial node profiles by decreasing this number and visaversa

  const viewportServerWidth = scaledCanvasWidth / serverToClientRatio;
  const viewportServerHeight = scaledCanvasHeight / serverToClientRatio;

  const halfServerWidth = viewportServerWidth / 2;
  const leftHalfServerWidth = -1 * halfServerWidth;
  const rightHalfServerWidth = halfServerWidth;

  const halfServerHeight = viewportServerHeight / 2;
  const leftHalfServerHeight = -1 * halfServerHeight;
  const rightHalfServerHeight = halfServerHeight;


  return [leftHalfServerWidth, leftHalfServerHeight, rightHalfServerWidth, rightHalfServerHeight];
}

export const isEmpty = (obj) => { // base.js
  for(var prop in obj) {
      if(obj.hasOwnProperty(prop))
          return false;
  }

  return JSON.stringify(obj) === JSON.stringify({});
}


export const assignMasterAndLengthToCycleClones = (nodeObjs) => { // sagas.js
  for (let nodeId in nodeObjs) {
    if(typeof(nodeObjs[nodeId].cidsArr) !== 'undefined'){
      nodeObjs[nodeId].cidsArr.map((nodeIdInCidsArr) => {
        nodeObjs[nodeIdInCidsArr].cyclemaster = nodeId;
        nodeObjs[nodeIdInCidsArr].cidsLength = nodeObjs[nodeId].cidsLength;
        return null;
      })
    }
  }
  return null;
}

export const getExpandedHeightForBubble = ({content, fontSizeMatchLabel, fontFamilyMatchLabel, width}) => {
  const contentKonvaText = new Konva.Text({
        x: 0,
        y: 0,
        text: content,
        fontSize: fontSizeMatchLabel,
        fontFamily: fontFamilyMatchLabel,
        width,
        align: 'center'
      });

   return ( typeof(content) === 'undefined' ? 0 : contentKonvaText.getHeight() );
}

export const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const addEvent = (object, type, callback) => {

  if (object == null || typeof(object) === 'undefined') return;
  if (object.addEventListener) {
      object.addEventListener(type, callback, false);
  } else if (object.attachEvent) {
      object.attachEvent("on" + type, callback);
  } else {
      object["on"+type] = callback;
  }

}

export const doWhenReady = ( {argument, condition, callback, attempts, fromWhere} ) => {
  // console.log(`argument: `, argument);
  if( !condition(argument) && attempts.ongoing <= attempts.end){
    attempts.ongoing++;
    // console.count('attempts');
    // console.log(/*'count for:', argument, */' fromWhere: ',fromWhere, ': ', attempts.ongoing);
    // console.log('--------------------------------');
    setTimeout( () => {
      doWhenReady({argument, condition, attempts, callback, fromWhere});
    }, 500);
  } else{
    callback();
  }
}

export const isInteger = (n) => {
  return n === +n && n === (n|0);
}


let debounceTimeout = null;
export const debounce = (callback) => {
  clearTimeout(debounceTimeout);
  debounceTimeout = setTimeout(() => {
   callback();
  }, 300);
}

export const buildRequestJsonPostOptions = (params) => {
  const headers = {
      'Content-Type': 'application/json; charset=utf-8',
      'X-Requested-With' : 'XMLHttpRequest',
      // 'Accept': 'application/json, text/plain, */*',
      'Accept': 'application/x-geni-jsonx, application/json, text/plain, */*',
      'X-Geni-Tree-Session-Id': treeSessionId,
  }
  const method = 'POST';
  const body = JSON.stringify({...params, authenticity_token: window.Geni.AuthenticityToken});
  return {
    headers,
    method,
    body,
  };

}

// export const buildRequestMultiPartMimePostOptions = (params) => {
//   const boundary = '----GeniFormBoundaryOWkqyMP70AhG3Q4';
//   const headers = {
//       'Content-Type': `multipart/form-data; boundary=${boundary}`,
//       'X-Requested-With' : 'XMLHttpRequest',
//       'Accept': 'application/x-geni-jsonx, application/json, text/plain, */*',
//       'X-Geni-Tree-Session-Id': treeSessionId,
//   }
//   const method = 'POST';
//   const form = {...params, authenticity_token: window.Geni.AuthenticityToken};

//   let body = '';
//   for(var key in form){
//     console.log(`key: `, key);
//     console.log(`f: `, form[key]);
//     console.log(`t: `, typeof(form[key])  );
//     body += "--" + boundary
//          + "\r\nContent-Disposition: form-data; name=" + key;
//     if( typeof(form[key]) === 'object' ){
//       body += "\r\nContent-type: " + form[key].type
//            + "\r\n\r\n" + form[key].value + "\r\n";
//     } else {
//       body += "\r\n\r\n" + form[key] + "\r\n";
//     }
//   }
//   body += "--" + boundary + "--\r\n"

//   return {
//     headers,
//     method,
//     body,
//   };

// }

export const isNewUserTree = ({nodeObjs, unions, focusNode}) => {

  // console.log(`{nodeObjs, unions, focusNode}: `, JSON.stringify({nodeObjs, unions, focusNode}, null, 2));

  const leftGhostParentNode = unions[0].p[0];
  const rightGhostParentNode = unions[0].p[1];
  return unions.length === 1 &&
    unions[0].c[0] === focusNode &&
    nodeObjs[leftGhostParentNode].nt === 'ghost' &&
    nodeObjs[rightGhostParentNode].nt === 'ghost'
};

export const removeUnionsWithNoParents = (unions) => {

  return unions.filter( (union) => typeof(union.p) !== 'undefined' );

};

export const getOffset = ( el )=>{
  el = el.getBoundingClientRect();
  return {
    left: el.left + window.pageXOffset,
    top: el.top + window.pageYOffset
  }
}


// export const getOffset = ( el ) => {
//     var _x = 0;
//     var _y = 0;
//     while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
//         _x += el.offsetLeft - el.scrollLeft;
//         _y += el.offsetTop - el.scrollTop;
//         el = el.offsetParent;
//     }
//     return { top: _y, left: _x };
// }


export const findIndexInData = (array, key, value)=>{
  for(var i = 0, l = array.length ; i < l ; i++) {
    if(array[i][key] === value) {
      return i;
    }
  }
  return -1;
}

export const removeFromArray = (array, key, value)=>{
  return array.filter(obj => obj[key] !== value);
}

export const toUpper = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
  // return str
  //   .toLowerCase()
  //   .split(' ')
  //   .map(function(word) {
  //     return word[0].toUpperCase() + word.substr(1);
  //   })
  //   .join(' ');
 };

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const titleCase = (str) => { // https://stackoverflow.com/questions/32589197/capitalize-first-letter-of-each-word-in-a-string-javascript/32589256
   var splitStr = str.toLowerCase().split(' ');
   for (var i = 0; i < splitStr.length; i++) {
       // You do not need to check if i is larger than splitStr length, as your for does that for you
       // Assign it back to the array
       splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
   }
   // Directly return the joined string
   return splitStr.join(' ');
}


export const oddcasesWhereHeightIsDoubleWidth = ({orientation, width, height}) => {
  return orientation === 'portrait' && height >= (width * 2)
}


export const animateToFocusThenFetchTreeSaga = ({
  callSetPageProfile,
  setDidRequestLoadTreeToTrue,
  fetchTree,
  node,
  panAnimateToNode,
  pr_id,
  reloadWithNewTree,
  setFlipPanelOpenAfterAnimateComplete,
  toggleNavigationalPanel,
  resetNavigationState,
  setNextNodeForPruning,
  setPrId,
  setPushToHistory,
  setStageClickCanZoomStep,
  showProgressIndicator,
  toggleFlipPanel,
  unSetStageClickCanZoomStep,
  userTouchedNode,
  zoomOutFromMobileFlipCard,
}) => {


  const afterPanningToNodeCallback = () => {
    resetNavigationState();
    showProgressIndicator({fromWhere: 'Tree link componenent'});
    setDidRequestLoadTreeToTrue();
    callSetPageProfile(pr_id, undefined, 'calc.js animateToFocusThenFetchTreeSaga');
    setPrId(pr_id);
    fetchTree({fromWhere: 'afterPanningToNodeCallback'});
    setPushToHistory();
    setStageClickCanZoomStep();

    /**
     *
     *
     *  The following causes bugs where props are not being proprogated to canvas component
     *
     *
     */
    // const prId =pr_id;
    // reloadWithNewTree({prId, node});
  }

  unSetStageClickCanZoomStep();

  if(isMobilePhone()){
    userTouchedNode({
    node,
    callback: ()=>{
      afterPanningToNodeCallback();
    },
    fromWhere: 'prunetree mobile phone'});

  }
  else if(isMobileTablet()){

    userTouchedNode({
      node,
      callback: ()=>{
          toggleFlipPanel({close: true, from: 'animateToFocusThenFetchTreeSaga at calc.js'});
          setFlipPanelOpenAfterAnimateComplete({how: false})
          toggleNavigationalPanel({direction: 'down'});
          setNextNodeForPruning(node); // Anynode that is not next node will disappear for animation effect
          panAnimateToNode({ node, callback: afterPanningToNodeCallback} );
          afterPanningToNodeCallback(); // Check this
      },
      fromWhere: 'prunetree mobile tablet'});

  }
  else { // desktop
    toggleFlipPanel({close: true, from: 'animateToFocusThenFetchTreeSaga at calc.js'});
    setNextNodeForPruning(node);
    setFlipPanelOpenAfterAnimateComplete({how: false})
    toggleNavigationalPanel({direction: 'down'});
    panAnimateToNode({ node, callback: afterPanningToNodeCallback} );
  }

}

export const detectMobileDeviceBrowser = () => {

  var mobileDevice;

  var height = window.screen.height;
  var width = window.screen.width;

  if( width === 414 && height === 736 && isSafari
  ){
    mobileDevice = 'iphonePlusSafari';
  }
  else if( width === 414 && height === 736 && !isSafari ){
    mobileDevice = 'iphonePlusChrome';
  }
  else if( width === 375 && height === 812 ){
    mobileDevice = 'iphoneX';
  }
  else if( width === 375 && height === 667 && isSafari
  ){
    mobileDevice = 'iphoneSafari';
  }
  else if( width === 375 && height === 667 && !isSafari
  ){
    mobileDevice = 'iphoneChrome';
  }
  else {
    mobileDevice = 'default';
  }

  return mobileDevice;
}

export const calcFullNameObj = ({nm, left, top}) => {

    left += 30;
    top += 2;

    if(typeof(nm) === 'undefined') nm = '';

    // nm ='George VI, King of the United Kingdom';
    // nm ='x x x x x x x x x x x x x x x x x x x x x x';
    // window.nameIs += 'x ';
    // nm = window.nameIs;

    // nm = '12345678901234';

    const fontSize = fullNameFontSize;
    const width = fullNameLineWidthDefaultTreeNormalFont;
    const fill = fullNameFontColor;
    const fontStyle = fullNameFontStyle;
    const lineHeight = fullNameLineHeight;

    // Also you can use .... https://github.com/lavrton/react-konva/issues/6
    const nmTextText = new Konva.Text({
          x: 0,
          y: 0,
          text: nm,
          fontSize,
          fontFamily,
          width,
          fontStyle,
          lineHeight,
          align: 'center'
        });

    const nmHeight = nmTextText.getHeight();

    if(nmHeight > 17.2) {

      nm = truncate(nm, {
        length: fullNameLineWidthDefaultTreeNormalFont * .85,
        separator: ' '
      })


    }

    const numOfCharactersThatWillFitInLine = 16;
    const height = ( nm.length <= numOfCharactersThatWillFitInLine ? 7: 14);

    // if(nm === "Dana Lynn Dienes"){
    //   console.log(`nmHeight: `, nmHeight);
    //   console.log(`height: `, height);
    // }

    return { nm, left, top, width, height, fontSize, lineHeight, fontStyle, fontFamily, fill};
}

export const calcNodeColorObj = ({
    focus,
    g,
    nodeObj,
    nodeObjs,
    minimap,
    bw,
    isPreview,
    isHover,
    maleCustomColor,
    femaleCustomColor,
    unGenderedCustomColor,
    undefinedGenderColor,
  }) => {

  if(typeof(nodeObj) === 'undefined') return;
    let strokeColor = null;

    var fillColor;

    const hovering = () => {
      return typeof(isHover) !== 'undefined' && isHover;
    }

    switch(g) {
      case 'm':
          fillColor = ( hovering() ? '#D3E7F3' : maleDefaultColor);
          if (typeof(maleCustomColor) !== 'undefined' ) fillColor = ( hovering() ? shadeColor(maleCustomColor, 10) : maleCustomColor);
          break;
      case 'f':
          fillColor = ( hovering() ? '#FBDAEC': femaleDefaultColor);
          if (typeof(femaleCustomColor) !== 'undefined' ) fillColor = ( hovering() ? shadeColor(femaleCustomColor, 10) : femaleCustomColor);
          break;
      case 'u':
          fillColor = ( hovering() ? '#E2F8B6': unGenderedDefaultColor);
          if (typeof(unGenderedCustomColor) !== 'undefined' ) fillColor = ( hovering() ? shadeColor(unGenderedCustomColor, 10) : unGenderedCustomColor);
          break;
      default:
          fillColor = (  typeof(undefinedGenderColor) !== 'undefined' ?  undefinedGenderColor: '#EFEFEF' )
          break;
    }


    const pedigreeGhostAddNodeDisabled = () => {
      return typeof(nodeObjs) !== 'undefined' && typeof(nodeObj.pedigreeGhostAddLabel) !== 'undefined' &&
      typeof(nodeObjs[nodeObj.pedigreeParentNodeId].a) === 'undefined'
    }

    if(pedigreeGhostAddNodeDisabled()){
      fillColor = '#EFEFEF';
    }

    const isFocus = () => {
      return typeof(focus) !== 'undefined' && focus === 1;
    }

    let fillLinearGradientColorStops = null;
    let yStartPointGradient = null;
    let yEndPointGradient = null;
    if( (isFocus()) ||
        (typeof(nodeObj.isPedigreePlaceHolder) !== 'undefined' && nodeObj.isPedigreePlaceHolder &&
        typeof(nodeObj.pedigreeGhostAddLabel) === 'undefined')
      ) {
      fillLinearGradientColorStops = [0, focusColor, 1, '#C0C0C0'];
      yStartPointGradient = 0;
      yEndPointGradient = nodeHeight * 2;
      strokeColor = '#C0C0C0';
    } else{
      fillLinearGradientColorStops = [0, 'white', 1, fillColor];
      yStartPointGradient = -30;
      yEndPointGradient = nodeHeight;
      strokeColor = fillColor;
    }
    if(typeof(g) === 'undefined') strokeColor = '#D3D3D3';


    if(pedigreeGhostAddNodeDisabled()){
        strokeColor = '#C0C0C0';
    }

    if( typeof(minimap) !== 'undefined'  &&
       (typeof(focus) !== 'undefined' && focus === 1)
    ){
      fillLinearGradientColorStops = [0, 'darkgray', 1, 'darkgray'];
      yStartPointGradient = -30;
      yEndPointGradient = nodeHeight;
      strokeColor = 'black';
    }

    if( typeof(bw) !== 'undefined' &&
       bw && typeof(isPreview) !== 'undefined' && isPreview
    ){
      fillLinearGradientColorStops = [0, '#D3D3D3', 1, '#D3D3D3'];
      yStartPointGradient = -30;
      yEndPointGradient = nodeHeight;
      strokeColor = 'darkgray';
    }
    else if( typeof(bw) !== 'undefined' &&
       bw
    ){
      fillLinearGradientColorStops = [0, isFocus() ? '#D3D3D3': 'white', 1, ( isFocus() ? '#D3D3D3': 'white' )];
      yStartPointGradient = -30;
      yEndPointGradient = nodeHeight;
      strokeColor = 'darkgray';
    }

    return {
      yStartPointGradient,
      fillLinearGradientColorStops,
      yEndPointGradient,
      strokeColor,
    }
}

// export const resetImageAsRealUploadedPic = ({nodeObj, setNodeObjPic}) =>{

//   const oddcasesWhereHeightIsDoubleWidth = ({orientation, width, height}) => {
//     return orientation === 'portrait' && height >= (width * 2)
//   }

//   // const {
//   //   // img,
//   // } = nodeObj;

//   const image = new window.Image();

//   // let cacheBreakPicsStr = '';
//   // if(cacheBreakPics){
//   //   cacheBreakPicsStr = '?cacheBust=' + Math.random();
//   //   // console.log('Implementing cache buster.');
//   //   setCacheBreakPicsFalse();
//   //   this.doOnce = false;
//   // }

//   image.src = nodeObj.img.src;//  + '?cacheBust=' + Math.random();

//   image.onload = () => {

//       let width = null;
//       let height = null;
//       let cropStartX = null;
//       let cropStartY = null;
//       let sideLength = null;
//       let diffPercent = null;
//       let orientation = null;

//       if( image.width > image.height){

//         orientation = 'landscape';
//         cropStartX = ((image.width - image.height) / 2);
//         cropStartY = 0;
//         sideLength = image.height;
//         width = image.width;
//         height = image.height;

//       } else {

//         orientation = 'portrait';
//         cropStartX = 0;
//         cropStartY = ((image.height - image.width) / 3);
//         sideLength = image.width;
//         width = image.width;
//         height = image.height;

//         diffPercent = image.height / image.width

//       }

//       const heightIsDoubleWidth = oddcasesWhereHeightIsDoubleWidth({orientation, width, height});

//       const imgObj = {...nodeObj.img, ...{
//         image,
//         width,
//         height,
//         cropStartX,
//         cropStartY,
//         sideLength,
//         diffPercent,
//         orientation,
//         heightIsDoubleWidth,
//       }}

//       setNodeObjPic({
//         node: nodeObj.n,
//         imgObj,
//       });

//   }
// }

export const doesExpiringUpsellExist = document.getElementById('expiring_pro_upsell');


export function getGenderColor({g, isFocus, isMock, color, isDisabled, nm, customColorObj}){

    let genderColor = undefined;
    let genderColorLight = undefined;

    if( typeof(customColorObj) !== 'undefined' ){

      genderColor = ( g === 'm' ? customColorObj.maleCustomColor: customColorObj.femaleCustomColor);
      genderColor = ( g === 'u' ? customColorObj.unGenderedCustomColor: genderColor);

      genderColorLight = ( g === 'm' ? shadeColor(customColorObj.maleCustomColor, 10): shadeColor(customColorObj.femaleCustomColor, 10));
      genderColorLight = ( g === 'u' ? shadeColor(customColorObj.unGenderedCustomColor, 10): genderColorLight);

    } else {

      genderColor = ( g === 'm' ? maleDefaultColor: femaleDefaultColor);
      genderColor = ( g === 'u' ? unGenderedDefaultColor: genderColor);

      genderColorLight = ( g === 'm' ? maleDefaultColorLight: femaleDefaultColorLight);
      genderColorLight = ( g === 'u' ? unGenderedDefaultColorLight: genderColorLight);

    }

    genderColorLight = ( isMock ? 'white': genderColorLight);
    genderColor = ( isMock ? color: genderColor);
    genderColor = ( isDisabled && isMock ? 'gray': genderColor);

    if(isFocus){
      genderColor = focusColor;
      genderColorLight = focusColor;
    }

    return {
      genderColor,
      genderColorLight
    };
}

export function getWidthOfText({txt, fontname, fontsize}){
    if(getWidthOfText.c === undefined){
        getWidthOfText.c = document.createElement('canvas');
        getWidthOfText.ctx = getWidthOfText.c.getContext('2d');
    }
    getWidthOfText.ctx.font = fontsize + ' ' + fontname;
    return getWidthOfText.ctx.measureText(txt).width;
}


export function buildNodeByRangeObjs({nodeObjsArray, furthestRight, rangeKeyIncrement}){
  let nodeObjsByRange = {};
  const keyIncrement = rangeKeyIncrement;
  for (let rangeKey = keyIncrement; rangeKey < ( furthestRight + keyIncrement ); rangeKey+=keyIncrement) {
    if( typeof(nodeObjsByRange[rangeKey]) === 'undefined' ) {
      nodeObjsByRange[rangeKey] = {
        imgCount: 0,
        nodeObjsArray: [],
      }
    }
    let imgCount = 0;
    nodeObjsByRange[rangeKey].nodeObjsArray = nodeObjsArray.filter((nodeObj)=>{
      return nodeObj.left >= rangeKey - keyIncrement && nodeObj.left < rangeKey;
    }).map((nodeObj)=>{
      const hasImg = ( nodeObj.img.type === 'real'  ? true: false );
      if( hasImg ) imgCount++;
      return {n: nodeObj.n, left: nodeObj.left/*, hasImg*/};
    });
    nodeObjsByRange[rangeKey].imgCount = imgCount;
  }
  return nodeObjsByRange
}

export function breakIdsIntoChunks({ids, chunkLength}){
  let chunks = [];
  let chunk = ids;
  while(chunk.length) {
    chunks.push(chunk.splice(0, chunkLength));
  }
  return chunks;
}

export function breakChunksIntoGroups({chunks, groupLength}){
  let groups = [];
  let group = chunks;
  while(group.length) {
    groups.push(group.splice(0, groupLength));
  }
  return groups;
}


export function downloadURI(uri, name) {
  var link = document.createElement('a');
  link.download = name;
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}


export function getContrastYIQ(hexcolor){
    hexcolor = hexcolor.replace("#", "");
    var r = parseInt(hexcolor.substr(0,2),16);
    var g = parseInt(hexcolor.substr(2,2),16);
    var b = parseInt(hexcolor.substr(4,2),16);
    var yiq = ((r*299)+(g*587)+(b*114))/1000;
    return (yiq >= 128) ? 'black' : 'white';
}

export function HSLToHex(h,s,l) {
  s /= 100;
  l /= 100;

  let c = (1 - Math.abs(2 * l - 1)) * s,
      x = c * (1 - Math.abs((h / 60) % 2 - 1)),
      m = l - c/2,
      r = 0,
      g = 0,
      b = 0;

  if (0 <= h && h < 60) {
    r = c; g = x; b = 0;
  } else if (60 <= h && h < 120) {
    r = x; g = c; b = 0;
  } else if (120 <= h && h < 180) {
    r = 0; g = c; b = x;
  } else if (180 <= h && h < 240) {
    r = 0; g = x; b = c;
  } else if (240 <= h && h < 300) {
    r = x; g = 0; b = c;
  } else if (300 <= h && h < 360) {
    r = c; g = 0; b = x;
  }
  // Having obtained RGB, convert channels to hex
  r = Math.round((r + m) * 255).toString(16);
  g = Math.round((g + m) * 255).toString(16);
  b = Math.round((b + m) * 255).toString(16);

  // Prepend 0s, if necessary
  if (r.length === 1)
    r = "0" + r;
  if (g.length === 1)
    g = "0" + g;
  if (b.length === 1)
    b = "0" + b;

  return "#" + r + g + b;
}

export function hexToHSL(H) {
  // Convert hex to RGB first
  let r = 0, g = 0, b = 0;
  if (H.length === 4) {
    r = "0x" + H[1] + H[1];
    g = "0x" + H[2] + H[2];
    b = "0x" + H[3] + H[3];
  } else if (H.length === 7) {
    r = "0x" + H[1] + H[2];
    g = "0x" + H[3] + H[4];
    b = "0x" + H[5] + H[6];
  }
  // Then to HSL
  r /= 255;
  g /= 255;
  b /= 255;
  let cmin = Math.min(r,g,b),
      cmax = Math.max(r,g,b),
      delta = cmax - cmin,
      h = 0,
      s = 0,
      l = 0;

  if (delta === 0)
    h = 0;
  else if (cmax === r)
    h = ((g - b) / delta) % 6;
  else if (cmax === g)
    h = (b - r) / delta + 2;
  else
    h = (r - g) / delta + 4;

  h = Math.round(h * 60);

  if (h < 0)
    h += 360;

  l = (cmax + cmin) / 2;
  s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
  s = +(s * 100).toFixed(1);
  l = +(l * 100).toFixed(1);

  return {h, s, l};
}

export const augmentNodesObj = ( {n, newProfilesObj, nodeObjsCopy, obj } ) => {

  let firstTreeMatchCountNode = undefined;
  let firstRecordMatchCountNode = undefined;
  const node = newProfilesObj[obj.pid];
  const {
      fn,  // first name
      ln,  // last name
      nm,  // name
      mn, // middle name
      mdn, // maiden name
      sfx, // suffix
      a, // adder ... if a = 1 use 'add this person' otherwise derive name from nm field
      e, // editable
      app, // add profile photo
      c, // c === 1 then make border blue
      mp, // mp === 1 then border is purple
      sh, // (public profiles) sh === 1 then make border green.
      nn,  // node number
      tm,  // tree match
      dob_c, // date of birth circa
      dod_c, // date of death circa
      dob_y, // date of birth year
      dod_y, // date of death year,
      vsum, // value summary
      rm, // record match
      sm, // smart match
      rm_vscore, // some MyHeritage tabulated score
      sm_vscore, // some MyHeritage tabulated score
      l, // if this dude is alive then... l = 1  / presumed-deceased then l = 2  / if undefined... then person is DEAD
      // t, // thumbnail
      g_e, // get_email  will be 1 if has empty email slot
      g, // gender
      gc, //gedcom
      dna,
      nvt,
      nvp,
      m_p, // merge pending
      inc, // inconsistency
      ntm, // nearby tree matches
      rl, // relationship-locked
      tmn, // first Tree match node
      rmn, // first record
    } = obj;

  let { t } = obj;

  // if( typeof(firstTreeMatchCountNode) === 'undefined' && node === '48'){
  if(  typeof(firstTreeMatchCountNode) === 'undefined' && typeof(tmn ) !== 'undefined' ){
    firstTreeMatchCountNode = node
  }

  // if( typeof(firstRecordMatchCountNode) === 'undefined' && node === '48'){
  if(  typeof(firstRecordMatchCountNode) === 'undefined' && typeof(rmn ) !== 'undefined' ){
    firstRecordMatchCountNode = node
  }

  // const thumbsArrayTest = [
  //   'https://s3.amazonaws.com/photos.geni.com/00/00/03/e7/sub73tid/000003e7_medium.jpg',
  //   'https://s3.amazonaws.com/photos.geni.com/p13/fc/90/36/0e/5344483e3eb1c378/20150724_043714_medium.jpg',
  //   'https://s3.amazonaws.com/photos.geni.com/p13/a9/45/69/ec/53444838b78e4da8/edith_and_joseph_bindel_medium.jpg',
  //   'https://s3.amazonaws.com/photos.geni.com/p13/b4/13/0b/8a/53444839fea36485/hyacinth_jessup_medium.jpg',
  //   'https://s3.amazonaws.com/photos.geni.com/p13/25/b5/f2/f7/53444842697253cb/blackburn_medium.jpg',
  // ];

  // t = thumbsArrayTest[4];

  var _t;
  let thumbImgType = null;
  if(typeof(t) === 'undefined') {
    _t = `${imageBasePath}no_photo_${nodeObjsCopy[n].g}.gif`;
    thumbImgType = 'placeholder';
  } else{
    thumbImgType = 'real'
    _t = t;
  }

  const {fullNameLineArr, fullNameLineArrWidth} = buildNameLineArray({nm});

  nodeObjsCopy[n].updated = true;
  nodeObjsCopy[n].n = n;
  nodeObjsCopy[n].fn = fn;
  nodeObjsCopy[n].ln = ln;
  nodeObjsCopy[n].nm = nm;
  nodeObjsCopy[n].mn = mn;
  nodeObjsCopy[n].mdn = mdn;
  nodeObjsCopy[n].sfx = sfx;
  nodeObjsCopy[n].fullNameLineArr = ( typeof(nm) !== 'undefined' ? fullNameLineArr: []);
  nodeObjsCopy[n].fullNameLineArrWidth = ( typeof(nm) !== 'undefined' ? fullNameLineArrWidth: []);
  nodeObjsCopy[n].a = a;
  nodeObjsCopy[n].e = e;
  nodeObjsCopy[n].app = app;
  nodeObjsCopy[n].c = c;
  nodeObjsCopy[n].mp = mp;
  nodeObjsCopy[n].sh = sh;
  nodeObjsCopy[n].photoBorderColor = derivePhotoBorderColor({c, mp, sh});
  nodeObjsCopy[n].nn = nn;
  nodeObjsCopy[n].dob_c = dob_c;
  nodeObjsCopy[n].dod_c = dod_c;
  nodeObjsCopy[n].dod_y = dod_y;
  nodeObjsCopy[n].dob_y = dob_y;
  nodeObjsCopy[n].vsum = vsum;
  nodeObjsCopy[n].g_e = g_e;
  nodeObjsCopy[n].g = g;
  nodeObjsCopy[n].dna = dna;
  nodeObjsCopy[n].l = l;
  // nodeObjsCopy[n].t = _t;
  nodeObjsCopy[n].img.src = _t;
  nodeObjsCopy[n].img.type = thumbImgType;
  nodeObjsCopy[n].sm_vscore = sm_vscore;
  nodeObjsCopy[n].rm_score = rm_vscore;

  nodeObjsCopy[n].vsum = getDummyText();
  nodeObjsCopy[n].vsum = vsum;
  nodeObjsCopy[n].tm = tm;
  nodeObjsCopy[n].rm = rm;
  nodeObjsCopy[n].sm = sm;
  nodeObjsCopy[n].gc = gc;
  nodeObjsCopy[n].dateAlive = buildDateAliveText({dob_c, dod_c, dob_y, dod_y, l});
  nodeObjsCopy[n].nvt = nvt;
  nodeObjsCopy[n].nvp = nvp;
  nodeObjsCopy[n].m_p = m_p;
  nodeObjsCopy[n].inc = inc;
  nodeObjsCopy[n].ntm = ntm;
  nodeObjsCopy[n].rl = rl;
  nodeObjsCopy[n].tmn = tmn;
  nodeObjsCopy[n].rmn = rmn;
  nodeObjsCopy[n].fetchedProfilesAt = Date.now();

  var _tm = (typeof(nodeObjsCopy[n].tm) !== 'undefined' ? nodeObjsCopy[n].tm : 0);
  var _rm = (typeof(nodeObjsCopy[n].rm) !== 'undefined' ? nodeObjsCopy[n].rm : 0);
  var _sm = (typeof(nodeObjsCopy[n].sm) !== 'undefined' ? nodeObjsCopy[n].sm : 0);

  var match_count = parseInt(_tm, 10) + parseInt(_rm, 10) + parseInt(_sm, 10);
  match_count = (match_count < 100 ? match_count.toString(): '99+');

  nodeObjsCopy[n].match_count = match_count;

  // if(!prodScript){
  //   const picUrl = fakeProfileImages.shift();
  //   nodeObjsCopy[n].t = picUrl;
  //   fakeProfileImages.push(picUrl);
  // }

  return {nodeObjsCopy, firstTreeMatchCountNode, firstRecordMatchCountNode};
}


/*
 *
 *
 * Fan Chart
 *
 *
 */



export const centerXFanchart = () => {
  return window.innerWidth/2 - 700;
};

export const centerYFanchart = () => {
  return ( isMobilePhone() || isMobileTablet() ? -50: 0)
};

export function prepareFanChart(focusNodeId, newData) {
  const focusNode = newData.nodes.find(node => node.n === focusNodeId);

  // console.log(`focusNodeId: `, focusNodeId);

  const union = newData.unions.find(union => {
    return union.c && union.c.includes(focusNodeId);
  });

  const parentNodeIds = (union && union.p) ? union.p : [];

  const parentNodes = parentNodeIds.map(parentNodeId =>
    prepareFanChart(parentNodeId, newData)
  );

  // Add a dummy node if there are no children
  if (parentNodes.length === 0) {
       //  console.log(union);
       // console.log(`%c union:${union}`, [
       //   'color: white',
       //   'background: orange',
       //   'font-size: 14px',
       //   'border: 5px solid red',
       //   'padding: 10px',
       //   ].join(';'));

  } else {



      // parentNodes.push({
      //   "node": {
      //     "fn": "James",
      //     "ln": "Ming",
      //     "nm": "James Ming",
      //     "pr_id": "-",
      //     "pid": "-",
      //     "g": "m",
      //     "n": 0,
      //     "ahn": 28
      //   },
      //   "parents": []
      // },
      // {
      //   "node": {
      //     "fn": "Landon",
      //     "ln": "Kent",
      //     "nm": "Landon Kent",
      //     "pr_id": "-",
      //     "pid": "-",
      //     "g": "f",
      //     "n": 0,
      //     "ahn": 29
      //   },
      //   "parents": []
      // });


  }

  const returnObj = {
    node: focusNode,
    parents: parentNodes
  };

  return returnObj;
}


